import { readLanguageQuery, updateLanguageQuery } from '../../utils/languageQuery';
export const DRIVER_LANGUAGE_KEY = "driver_language";
export const DRIVER_LANGUAGE_CHANGED_EVENT = "driver-language-changed";

export const driverLanguages = [
  { code: "zh_cn", label: "简体中文" },
  { code: "zh_tw", label: "繁體中文" },
  { code: "ja", label: "日本語" },
  { code: "en", label: "English" },
];

export const driverText = {
  ja: {
    loading: "読み込み中...",
    cachedData: "現在は保存済みデータを表示しています",
    offlineOrderPackReady: (count) => `今後48時間のオフライン予約 ${count}件を保存済み`,
    offlineSignboardReady: (count) => `サインボードPDF ${count}件`,
    offlineSignboardUnavailable: "オフライン用サインボードPDFがまだ保存されていません。接続後に予約一覧を更新してください",
    nextOrder: "次の予約",
    myOrders: "予約一覧",
    conversations: "チャット",
    conversationListHint: "チャット開始後は進行中に表示され、予約開始24時間後に完了へ移動します",
    activeConversations: "進行中",
    completedConversations: "完了",
    noActiveConversations: "進行中の予約チャットはありません",
    noCompletedConversations: "完了した予約チャットはありません",
    noConversations: "利用できる予約チャットはありません",
    myPage: "マイページ",
    myPageTab: "私",
    profilePhotoMenuTitle: "プロフィール写真を変更",
    chooseFromAlbum: "アルバムから選択",
    takeProfilePhoto: "写真を撮る",
    orderPool: "予約プール",
    poolOrders: "予約プール",
    applyOrder: "応募する",
    applyingOrder: "応募中...",
    cancelApplication: "応募取消",
    applicationPending: "応募済み",
    applySuccess: "受注しました",
    poolDisabled: "現在、新規受注はできません",
    orderPoolOnboardingRequired: "乗務開始資料の審査が完了すると受注できます",
    orderPoolExpiredDocumentRequired: (name) => `${name}資料の期限が切れています。更新後に受注してください`,
    orderPoolTemporarilyUnavailable: "現在は受注できません",
    documentExpiryNames: { driver_license: "運転免許", residence_card: "在留カード", passport: "パスポート", vehicle_inspection: "車検証", optional_insurance: "任意保険" },
    noPoolOrders: "受注できる予約はありません\n新しい予約が公開されるとすぐにお知らせします\nAppの通知をオンにしてください",
    poolDecisionHint: "予約公開後30分以内は、スコアの高いドライバーへ優先的に配車されます",
    dispatchPriceLabel: "配車価格",
    driverScore: "現在のスコア",
    driverScoreHint: "完了率・キャンセル・クレーム状況に基づき自動更新されます",
    monthlyRevenueTitle: "今月の売上 / 報酬",
    monthlyCompletedOrders: "今月の完了件数",
    monthlyReward: "今月の報酬",
    monthlyUnsettled: "未精算",
    myWallet: "マイウォレット",
    settlement: "精算",
    viewDetails: "詳細を見る",
    walletDetailsTitle: "精算明細",
    walletOrderAmount: "注文金額",
    walletOvertimeFee: "延長料金",
    walletSettlementDate: "精算日",
    walletPaymentStatus: "振込状況",
    walletPaid: "振込済み",
    walletUnpaid: "未振込",
    walletNoDetails: "精算明細はまだありません",
    scoreDetailsTitle: "スコア明細",
    scoreNoDetails: "スコア明細はまだありません",
    scoreOldNew: "スコア変化",
    scoreAdjustment: "スコア調整",
    scoreEventTypes: {
      order_completed_bonus: "完了ボーナス",
      driver_complaint_penalty: "クレーム減点",
      completed_bonus_reversed_by_complaint: "完了ボーナス取消",
      driver_complaint_reversed: "クレーム取消",
      completed_bonus_restored_after_complaint_reverse: "完了ボーナス復元",
      order_return_penalty: "予約返却ペナルティ",
    },
    currentMonthSettlementAmount: "当月精算額",
    nextMonthSettlementAmount: "翌月精算額",
    driverSettlementRule: "1日から月末までの注文は、翌月15日に精算されます",
    canAcceptOrders: "新規受注可",
    cannotAcceptOrders: "新規受注停止中",
    onboardingTitle: "乗務開始チェック",
    businessStartCheck: "すべての項目が完了すると受注を開始できます",
    businessStartCheckHint: "個人情報、車両情報、研修、整備場チェックを順番に完了してください",
    documentManagement: "資料 / 証件管理",
    documentManagementTitle: "プロフィール・証件管理",
    documentManagementHint: "免許証、車検証、保険、在留カード/日本国籍、銀行口座",
    personalDocumentsTitle: "個人資料 / 証件",
    personalDocumentsHint: "免許証、在留カード、連絡先",
    vehicleDocumentsTitle: "車両資料",
    vehicleDocumentsHint: "車検証、保険、車両写真",
    payoutAccountTitle: "受取口座",
    payoutAccountHint: "銀行口座、精算情報",
    documentExpired: "期限切れ資料があります",
    documentExpiredCount: "件の期限切れ",
    documentExpiredAutoPause: "期限切れ資料があるため、新規受注は自動停止されます。",
    documentExpiringSoon: (count) => `${count}件の資料が30日以内に期限切れになります。早めに更新してください。`,
    documentSaved: "資料を保存しました",
    needsCompletion: "未完了",
    driverLicenseInfo: "免許証情報",
    vehicleInspectionDocument: "車検証",
    vehicleInspectionExpiry: "車検証期限",
    optionalInsurance: "任意保険",
    optionalInsuranceCompany: "保険会社名",
    optionalInsurancePolicyNumber: "保険証券番号",
    optionalInsuranceExpiry: "任意保険期限",
    optionalInsuranceFront: "任意保険 表",
    optionalInsuranceBack: "任意保険 裏",
    residenceOrPassport: "在留カード / 日本国籍",
    residenceCardNumber: "在留カード番号",
    japaneseNational: "日本国籍",
    validUntil: "有効期限",
    longTermValid: "長期有効",
    bankAccount: "銀行口座",
    bankName: "銀行名",
    bankBranch: "支店名",
    bankAccountType: "口座種別",
    bankAccountTypeOptions: [{ value: "", label: "選択してください" }, { value: "普通", label: "普通" }, { value: "当座", label: "当座" }],
    bankAccountNumber: "口座番号",
    bankAccountHolder: "口座名義",
    saveDocuments: "資料を保存",
    onboardingSubmitted: "提出しました。管理者の確認をお待ちください",
    trainingPassed: "研修テストに合格しました",
    personalInfo: "個人情報",
    fullName: "氏名",
    dateOfBirth: "生年月日",
    address: "住所",
    driverServiceLanguages: "対応できる言語",
    driverServiceLanguageNames: {
      ja: "日本語",
      en: "英語",
      es: "スペイン語",
      ko: "韓国語",
      zh: "中国語",
    },
    chooseFromAlbum: "アルバムから選択",
    takeProfilePhoto: "撮影",
    openAlbumOrChooseFile: "アルバム/ファイルを選択",
    noFileSelected: "ファイル未選択",
    fileSelected: "選択済み",
    onboardingMissingFields: "未入力または未選択の必須項目があります",
    onboardingFileTooLarge: "ファイルが大きすぎます。画像を撮り直すか、より小さいファイルを選択してください。",
    onboardingFileReadFailed: "ファイルを読み込めませんでした。もう一度選択してください。",
    residenceCardExpiry: "在留カード期限",
    driverLicenseNumber: "運転免許証番号",
    driverLicenseExpiry: "運転免許期限",
    residenceCardFront: "在留カード 表",
    residenceCardBack: "在留カード 裏",
    driverLicenseFront: "運転免許 表",
    driverLicenseBack: "運転免許 裏",
    plateRegion: "管轄地名",
    plateClass: "分類番号",
    plateKana: "ひらがな",
    plateDigits: "一連指定番号",
    vehicleModel: "車両モデル",
    vehicleModelOptions: [{ value: "alphard", label: "アルファード" }, { value: "hiace", label: "ハイエース" }],
    vehicleColor: "車両色",
    vehicleColorOptions: [{ value: "black", label: "黒" }],
    vehicleYear: "年式（2016年以降）",
    inspectionCertificate: "車検証",
    recordCertificate: "記録事項書",
    optionalInsurancePhoto: "任意保険写真",
    compulsoryInsuranceExpiry: "自賠責期限",
    compulsoryInsurancePhoto: "自賠責写真",
    training: "乗務前研修",
    submitTraining: "テストを提出",
    trainingLessonProgress: "学習",
    trainingMaterial: "学習資料",
    trainingUnderstandPage: "本ページの内容を理解しました",
    trainingConfirmed: "確認済み",
    trainingNext: "次へ",
    trainingPrev: "前へ",
    trainingStartTest: "テストへ進む",
    trainingLocked: "すべての学習資料を確認すると、研修テストに進めます。",
    trainingWrongHint: "未正解の問題があります。該当する学習資料を確認してから再度提出してください。",
    trainingCritical: "重要",
    vehicleInspection: "指定整備場チェック",
    inspectionLocation: "整備場名",
    inspectionCompleted: "車両チェック完了",
    labelAttached: "ステッカー貼付完了",
    inspectionSite: "指定整備場",
    inspectionAddressPending: "整備場住所は管理者が案内します",
    inspectionFutureSelectable: "現在は1か所のみ。今後、選択式に対応予定です。",
    appointmentDate: "予約日",
    appointmentTime: "予約時間（30分単位）",
    inspectionNoticeTitle: "確認事項",
    inspectionFeeWarning: "JPY 5,000は、対面で行う車両検査と実物のBig Taxi会社ラベルに対する費用です。デジタル機能やAppの利用権を購入するものではありません。車両または服装が現地検査基準を満たさない場合、この費用は返金されません。",
    confirmInspectionAppointment: "予約内容を確認",
    inspectionPaymentStep: "車両検査費用",
    payInspectionFee: "対面車両検査・実物ラベル費用を支払う",
    inspectionQrTitle: "整備場確認コード",
    inspectionQrHint: "支払い後、このQRコードと8桁コードを保存して整備場で提示してください。",
    inspectionPaymentStatus: "支払い状況",
    paymentSetupRequired: "Square決済設定が未完了です",
    paymentLinkFailed: "支払い画面を準備できませんでした。もう一度お試しください。",
    inspectionPaymentStatusLabels: { pending: "未払い", created: "支払い待ち", payment_setup_required: "決済設定待ち", payment_link_failed: "支払い準備失敗", paid: "支払い済み", completed: "支払い済み", canceled: "キャンセル", cancelled: "キャンセル", failed: "支払い失敗" },
    squareTrust: "カード情報はSquareにより安全に処理され、弊社では保存しません。",
    pending: "未完了",
    onboardingStatus: { pending: "未完了", submitted: "確認待ち", approved: "完了", rejected: "差戻し" },
    auditStatus: "審査状況",
    rejectionReason: "差戻し理由",
    onboardingAuditStates: { pending_submission: "未提出", reviewing: "審査中", needs_changes: "修正が必要", approved: "承認済み" },
    onboardingItemStatus: { to_complete: "未完了", reviewing: "審査中", needs_changes: "修正が必要", completed: "完了", incomplete: "未完了", not_started: "未開始" },
    onboardingSteps: { personal_info: "個人情報", vehicle_info: "車両情報", training: "乗務前研修", vehicle_inspection: "整備場チェック", final_review: "最終審査" },
    settings: "設定",
    fleetJoinTitle: "フリートに参加",
    fleetJoinHint: "承認済みのフリートに参加する場合は、責任者から共有された固定フリートコードを入力してください。",
    fleetCodePlaceholder: "フリートコードを入力",
    fleetJoin: "参加する",
    fleetJoining: "参加中…",
    fleetJoinSuccess: "フリートに参加しました",
    fleetJoinFailed: "フリートへの参加に失敗しました。コードを確認してもう一度お試しください。",
    fleetMembershipLabel: "所属フリート",
    fleetMembershipTitle: "所属フリート",
    fleetMembershipUnknown: "フリート情報を確認中",
    fleetMembershipHint: "現在所属しているフリートです。",
    fleetExitRequest: "フリート退出を申請",
    fleetExitRequestHint: "理由を送信すると、フリート責任者が確認します。承認後は別のフリートに参加できます。",
    fleetExitReasonPlaceholder: "退出したい理由を入力してください",
    fleetExitSubmitting: "送信中…",
    fleetExitRequestPending: "退出申請はフリート責任者の確認待ちです",
    fleetExitRequestSuccess: "退出申請を送信しました。フリート責任者の確認をお待ちください。",
    fleetExitRequestFailed: "退出申請を送信できませんでした。もう一度お試しください。",
    fleetManagementTitle: "フリート管理",
    fleetManagementHint: "配車、ドライバーアカウント、フリート設定を管理します。",
    fleetMasterAccount: "フリート管理者アカウント",
    fleetDrivers: "ドライバー",
    fleetVehicles: "車両",
    fleetDispatchableOrders: "配車待ち",
    timeOff: "休暇申請",
    upcoming: "出発予定",
    completed: "完了",
    goComplete: "完了する",
    all: "すべて",
    add: "追加",
    refresh: "更新",
    official: "予約",
    unreadMessage: "新着",
    noOrders: "予約はありません",
    unknownCustomer: "お客様未設定",
    downloadPdf: "PDF",
    downloading: "処理中...",
    addToCalendar: "カレンダー追加",
    addedToCalendar: "カレンダー追加済み",
    calendarDateMissing: "予約日時が未設定のため、カレンダーに追加できません",
    calendarPermissionDenied: "iPhoneの設定でカレンダー追加を許可してください",
    calendarNativeUnavailable: "カレンダー機能を準備できませんでした。アプリを再起動してください",
    reportedAt: "報告済み",
    reportDuration: "時間報告",
    dispatchPrice: "配車価格",
    fleetAssignedDriver: "実際のドライバー",
    fleetUnassigned: "未配車",
    fleetAssignDriver: "ドライバーを配車",
    fleetReassignDriver: "配車変更",
    fleetChooseDriver: "ドライバーを選択",
    fleetChooseVehicle: "車両を選択",
    fleetSelectedDriver: "選択したドライバー",
    fleetAssignedVehicle: "実際の車両",
    fleetAssignVehicle: "この車両を指定",
    fleetNoSavedVehicles: "保存済みの車両がありません。上のボタンから追加してください。",
    fleetAddVehicle: "新しい車両を追加",
    fleetVehicleType: "車種",
    fleetPlateNumber: "ナンバープレート",
    fleetPlatePlaceholder: "例：品川 500 あ 1234",
    fleetVehicleSaveHint: "保存後、この予約にすぐ指定され、次回から一覧で選べます。",
    fleetSaveAndAssign: "保存して指定",
    fleetDeleteVehicle: "削除",
    fleetVehicleDeleted: "車両を一覧から削除しました",
    change: "変更",
    vehicle: "車両",
    fleetAssigning: "配車中...",
    fleetAssignmentLocked: "サービス開始後は配車変更できません",
    fleetNoAvailableDrivers: "配車可能なドライバーがいません",
    fleetOrderReadOnly: "この予約はフリート所属の予約です。実行操作は担当ドライバーのみ行えます。",
    orderDetail: "予約詳細",
    back: "戻る",
    orderStatus: "予約状況",
    booking: "予約",
    service: "サービス",
    driver: "ドライバー",
    statusActions: "状態操作",
    chooseIssue: "異常項目を選択",
    issuePlaceholder: "問題内容を入力",
    submitIssue: "異常を送信",
    dateTime: "日時",
    charterDuration: "貸切時間",
    hours: "時間",
    dispatchContact: "配車連絡",
    dispatchNote: "配車メモ",
    tripInfo: "行程情報",
    terminal: "ターミナル",
    flightNumber: "便名 / 船便",
    passengerInfo: "お客様情報",
    passengerName: "お客様名",
    customerCode: "顧客コード",
    phone: "電話番号",
    passengerCount: "人数",
    luggageCount: "荷物",
    childSeats: "チャイルドシート",
    peopleUnit: "名",
    luggageUnit: "個",
    vehicleInfo: "車両情報",
    vehicleType: "車種",
    plateNumber: "ナンバー",
    brand: "ブランド",
    extraServices: "追加サービス",
    notes: "備考",
    reportCharterTime: "貸切時間を報告",
    reportedEndTime: "報告済み終了時刻",
    modifyEndTime: "終了時刻を変更",
    reportEndTime: "貸切終了時刻を報告",
    orderNo: "予約番号",
    startTime: "開始時刻",
    bookedDuration: "予約時間",
    actualEndTime: "実際の終了時刻（30分単位）",
    submit: "送信",
    editExtraOrder: "変更",
    submitConfirm: "確定",
    submitting: "送信中...",
    selectEndTime: "終了時刻を選択",
    enterChat: "チャットへ",
    unreadEnterChat: "新着メッセージがあります",
    tripCommunicationCenter: "予約チャット",
    driverSections: "ドライバー画面",
    route: "ルート",
    changePassword: "パスワード変更",
    faceIdLogin: "Face IDでログイン",
    faceIdLoginHint: "保存済みのアカウントとパスワードで次回からすばやくログインできます",
    faceIdChecking: "Face IDを確認しています...",
    faceIdEnabled: "Face IDログインを有効にしました",
    faceIdDisabled: "Face IDログインを無効にしました",
    faceIdUnavailable: "この端末ではFace IDを利用できません",
    faceIdCredentialRequired: "一度ログアウトし、ログイン画面で「アカウントを保存」を選んでからFace IDを有効にしてください",
    faceIdAuthFailed: "Face IDが起動しませんでした。端末のFace ID設定を確認してから再度お試しください",
    loginWithFaceId: "Face IDでログイン",
    faceIdReason: "Big Taxi DriverにログインするためFace IDで認証してください",
    emergencyContact: "緊急サポート",
    emergencyContactHint: "サービス中のトラブルや緊急時に使用します",
    contactDispatch: "配車担当に連絡",
    onlineBigTaxiSupport: "配車センターにオンライン連絡",
    phoneBigTaxiSupport: "配車センターに電話連絡",
    customerServicePhoneNumber: "カスタマーサポート電話番号",
    callBigTaxiSupportPrompt: "配車センターへ発信します",
    callNow: "発信",
    close: "閉じる",
    reportAccidentTrouble: "事故・トラブル報告",
    openOrderDetailToReport: "予約詳細から報告",
    legalComplianceCenter: "法務・コンプライアンス",
    legalComplianceCenterHint: "利用条件、個人情報、位置情報、通知に関する重要事項を確認できます",
    termsOfUse: "利用規約",
    privacyPolicy: "プライバシーポリシー",
    viewFullPrivacyPolicy: "プライバシーポリシー全文を開く",
    privacyPolicyBody: "Big Taxi Driverでは、配車、本人確認、精算、緊急対応、品質管理に必要な範囲で個人情報を取り扱います。\n\n取得する情報には、氏名、連絡先、本人確認書類、車両情報、銀行口座、ログイン端末情報、アプリ利用記録が含まれます。\n\n取得した情報は、業務運営、法令対応、安全確認、不正利用防止、サービス改善の目的で利用します。業務上必要な場合、調度担当、管理者、決済・本人確認・システム提供会社に必要最小限の情報を共有することがあります。",
    locationInformation: "位置情報について",
    locationInformationBody: "位置情報は、予約状況の確認、到着・乗車・完了などのステータス記録、緊急時対応、トラブル発生時の事実確認のために使用します。\n\nステータスを更新した時刻と位置は、注文履歴と管理画面に記録されます。常時監視を目的とするものではなく、配車業務と安全確認に必要な範囲で利用します。\n\n位置情報の権限を無効にすると、一部のステータス更新、証跡記録、緊急対応が正しく行えない場合があります。",
    notificationInformation: "通知について",
    notificationInformationBody: "通知は、新規予約、予約変更、キャンセル、調度からの連絡、乗客からのメッセージ、緊急連絡を受け取るために使用します。\n\nロック画面に表示される通知は簡潔な内容にし、電話番号、ホテル部屋番号、詳細な個人情報などの機微情報は本文に表示しません。\n\n通知を無効にすると、重要な予約変更や緊急連絡に気づくのが遅れる可能性があります。",
    safeDrivingGuide: "安全運転ガイド",
    safeDrivingGuideBody: "運行中は道路交通法を遵守し、安全を最優先してください。無理な速度、急発進、急ブレーキ、ながら運転、体調不良時の運転は禁止です。\n\n車内は清潔に保ち、飲用水、掲示物、車両状態、服装など会社指定の基準を守ってください。\n\n事故、遅延、乗客トラブル、忘れ物、車両不具合が発生した場合は、自己判断で処理せず、速やかに調度へ連絡してください。",
    emergencyResponse: "緊急時対応",
    emergencyResponseBody: "人身事故、物損事故、急病、車両故障、乗客との重大トラブルが発生した場合は、まず安全確保を行い、必要に応じて警察・消防・救急へ連絡してください。\n\nその後、アプリの緊急連絡または配車担当へ状況、場所、注文番号、乗客の安全状況を報告してください。\n\n現場での約束、返金、補償判断は単独で行わず、必ず管理者の指示を受けてください。",
    accountSuspensionScoreRules: "アカウント停止とスコアルール",
    accountSuspensionScoreRulesBody: "ドライバースコアは、完了率、キャンセル、遅延、クレーム、服装・車両基準、連絡対応、異常報告の内容に基づき自動または管理者により更新されます。\n\n重大な規約違反、虚偽報告、無断キャンセル、危険運転、個人情報の不適切な取り扱い、クレーム累積、書類期限切れがある場合、受注機能が一時停止されることがあります。\n\nスコアが基準を下回った場合、または必要書類が期限切れになった場合、既存予約の確認はできますが、新規受注は禁止されます。",
    deviceManagement: "デバイス管理",
    loginDeviceManagement: "ログインデバイス管理",
    loginDeviceManagementHint: "ログイン済みデバイスを確認・削除できます",
    loginDevicesEmpty: "ログイン済みデバイスはありません",
    currentDevice: "現在のデバイス",
    lastLoginAt: "最終ログイン",
    removeDevice: "削除",
    removingDevice: "削除中...",
    loginDeviceRemoved: "ログインデバイスを削除しました",
    loginDeviceLoadFailed: "デバイス一覧を取得できませんでした",
    loginDeviceRemoveFailed: "デバイスを削除できませんでした",
    aboutApp: "アプリ情報",
    versionNumber: "ドライバーアプリ",
    notificationSettings: "通知設定",
    languageSettings: "言語設定",
    languageSettingsHint: "アプリの表示言語を変更できます",
    languageSaved: "表示言語を変更しました",
    driverNoticeTitle: "お知らせ",
    driverNoticeHistory: "お知らせ",
    driverNoticeEmpty: "お知らせはありません",
    importantNotificationTitle: "重要な通知",
    importantNotificationAck: "確認しました",
    importantNotificationOpenOrder: "予約を見る",
    importantNotificationCreatedAt: "通知日時",
    importantNotificationPending: "未確認",
    importantNotificationSaving: "送信中…",
    importantNotificationFailed: "確認結果を受信できませんでした。保存済みの可能性があります。再試行するか、後で確認してください。",
    importantNotificationLater: "後で確認（未確認のまま）",
    orderChangeUpdated: "更新あり",
    orderChangeTime: "時間",
    orderChangePickup: "乗車地",
    orderChangeDropoff: "降車地",
    orderChangeNote: "メモ",
    orderChangeCancelled: "キャンセル",
    newReservationNotification: "新規予約通知",
    reservationChangeNotification: "予約変更通知",
    urgentContactNotification: "緊急連絡通知",
    notificationSettingsSaved: "通知設定を保存しました",
    logout: "ログアウト",
    driverAppVersion: "2.0",
    firstLoginChangePassword: "初回ログイン：パスワード変更",
    currentPassword: "現在のパスワード",
    newPassword: "新しいパスワード",
    confirmNewPassword: "新しいパスワード確認",
    currentPasswordPlaceholder: "現在のパスワードを入力",
    newPasswordPlaceholder: "6文字以上",
    confirmPasswordPlaceholder: "もう一度入力",
    passwordTooShort: "新しいパスワードは6文字以上必要です",
    passwordMismatch: "パスワードが一致しません",
    passwordChanged: "パスワードを変更しました",
    systemConfigError: "システム設定エラーです。管理者に連絡してください",
    passwordChangeFailed: "パスワード変更に失敗しました",
    timeOffRequest: "休暇申請",
    timeOffHint: "申請後すぐに反映され、配車時に確認できます",
    startDate: "開始日",
    endDate: "終了日",
    allDayRange: "終日休暇 / 日付範囲",
    endTime: "終了時刻",
    reason: "備考",
    reasonPlaceholder: "例：私用、病院、家庭の予定など",
    submitTimeOff: "休暇を申請",
    myTimeOffRecords: "休暇履歴",
    noTimeOffRecords: "休暇履歴はありません",
    cancelled: "取消済み",
    active: "有効",
    timeOffRegistered: "休暇を登録しました",
    getTimeOffFailed: "休暇履歴の取得に失敗しました",
    submitFailed: "送信に失敗しました",
    cancelFailed: "取消に失敗しました",
    chooseStartDate: "開始日を選択してください",
    chooseStartEndTime: "開始時刻と終了時刻を選択してください",
    confirmCancelTimeOff: "この休暇を取り消しますか？",
    fullDay: "終日",
    loginExpired: "ログイン期限が切れました。再ログインしてください",
    accountDisabled: "アカウントが無効です。管理者に連絡してください",
    orderFetchFailed: "予約の取得に失敗しました",
    unknownError: "不明なエラー",
    unknownStatus: "状態未確認",
    networkError: "ネットワークエラーです。接続を確認してください",
    reportSuccess: "報告しました",
    reportFailed: "報告に失敗しました",
    cancelExtraConfirm: "この追加予定を取り消しますか？",
    extraServiceTypes: {
      airport_sign: "空港サインボード",
      infant_seat: "ベビーシート",
      airport_pickup_sign: "空港サインボード",
      hotel_sign: "ホテルサインボード",
      english_driver: "英語対応ドライバー",
      tokyo_station_platform: "東京駅ホーム送迎",
      platform_dropoff: "駅ホーム送迎",
      tokyo_station_sign: "東京駅サインボード",
      odawara_station_sign: "小田原駅サインボード",
      shinkansen_ticket: "新幹線チケット手配",
      hiace_14_seat_upgrade: "14人乗りハイエースへ変更",
      fuji_5th_station: "富士山五合目追加費",
      child_seat: "チャイルドシート",
      extended_waiting_time: "待機時間延長",
      other: "その他サービス",
    },
    openMap: "地図を確認",
    mapConfirm: "地図確認",
    pickup: "乗車地",
    dropoff: "降車地",
    appleMaps: "Appleマップ",
    googleMaps: "Google Maps",
    startNavigation: "ナビを開く",
    cancel: "キャンセル",
    retryPending: "未送信の状態を再送しています",
    statusUpdated: "状態を更新しました",
    statusQueued: "通信が不安定です。状態を保存し、接続復旧後に自動送信します",
    statusSyncing: "未送信の状態を同期中です",
    statusSynced: "未送信の状態を同期しました",
    statusPendingCount: "未送信の状態",
    issueReport: "異常報告",
    cancelIssueReport: "異常報告を取り消す",
    issueReportCancelled: "異常報告を取り消しました",
    returnOrder: "予約を返却",
    returnOrderTitle: "返却理由",
    returnOrderPlaceholder: "任意で理由を入力",
    returnOrderSwipe: "予約をプールへ返却",
    returnOrderConfirm: "この予約を返却しますか？",
    returnOrderSuccess: "予約を返却しました",
    returnOrderFailed: "予約の返却に失敗しました",
    swipeToConfirm: "右へスライド",
    pleaseWait: "しばらくお待ちください",
    status: {
      pending: "未確認",
      pending_confirmation: "未確認",
      confirmed: "確定",
      completed: "完了",
      cancelled: "取消",
    },
    driverStatus: {
      assigned: "確認待ち",
      confirmed: "確認済み",
      driver_departed: "出発済み",
      arrived_pickup: "乗車地到着",
      passenger_onboard: "乗車済み",
      in_service: "サービス中",
      completed: "完了",
      issue_reported: "異常報告済み",
    },
    driverActions: {
      confirmed: "予約を確認",
      driver_departed: "出発",
      arrived_pickup: "乗車地に到着",
      passenger_onboard: "お客様乗車済み",
      in_service: "サービス開始",
      completed: "完了",
    },
    serviceType: {
      transfer: "送迎",
      charter: "貸切",
    },
    issueOptions: {
      unable_contact_passenger: "お客様に連絡がつかない",
      passenger_no_show: "お客様が現れない",
      passenger_late: "お客様が遅れている",
      flight_or_train_delay: "便 / 列車遅延",
      pickup_location_problem: "乗車地が不明確",
      route_or_destination_changed: "ルート / 目的地変更",
      extra_waiting_time: "追加待機が必要",
      luggage_or_item_left: "忘れ物あり",
      vehicle_or_traffic_issue: "車両 / 交通トラブル",
      order_information_problem: "予約情報に誤り",
      other: "その他",
    },
  },
  en: {
    loading: "Loading...",
    cachedData: "Showing saved data",
    offlineOrderPackReady: (count) => `${count} orders for the next 48 hours saved offline`,
    offlineSignboardReady: (count) => `${count} signboard PDFs`,
    offlineSignboardUnavailable: "This signboard PDF is not cached yet. Refresh My Orders when you are online.",
    nextOrder: "Next Order",
    myOrders: "My Orders",
    conversations: "Chats",
    conversationListHint: "Opened chats stay ongoing until 24 hours after the order starts",
    activeConversations: "Ongoing",
    completedConversations: "Completed",
    noActiveConversations: "No ongoing order chats",
    noCompletedConversations: "No completed order chats",
    noConversations: "No order chats are available",
    myPage: "Me",
    myPageTab: "Me",
    profilePhotoMenuTitle: "Change profile photo",
    chooseFromAlbum: "Choose from album",
    takeProfilePhoto: "Take photo",
    orderPool: "Order Pool",
    poolOrders: "Order Pool",
    applyOrder: "Accept Order",
    applyingOrder: "Submitting...",
    cancelApplication: "Cancel Request",
    applicationPending: "Requested",
    applySuccess: "Order accepted",
    poolDisabled: "New order acceptance is disabled",
    orderPoolOnboardingRequired: "Complete onboarding review to accept orders",
    orderPoolExpiredDocumentRequired: (name) => `${name} document is expired. Update it before accepting orders`,
    orderPoolTemporarilyUnavailable: "Order acceptance is temporarily unavailable",
    documentExpiryNames: { driver_license: "Driver license", residence_card: "Residence card", passport: "Passport", vehicle_inspection: "Vehicle inspection", optional_insurance: "Insurance" },
    noPoolOrders: "No available orders\nWe will notify you immediately when a new order is published\nPlease keep App notifications enabled",
    poolDecisionHint: "Within 30 minutes after an order is published, the system prioritizes drivers with higher scores",
    dispatchPriceLabel: "Dispatch Price",
    driverScore: "Current Score",
    driverScoreHint: "Automatically updated based on completion rate, cancellations, and complaint status",
    monthlyRevenueTitle: "Monthly Sales / Reward",
    monthlyCompletedOrders: "Completed This Month",
    monthlyReward: "Reward This Month",
    monthlyUnsettled: "Unsettled",
    myWallet: "My Wallet",
    settlement: "Settlement",
    viewDetails: "View Details",
    walletDetailsTitle: "Settlement Details",
    walletOrderAmount: "Order Amount",
    walletOvertimeFee: "Overtime Fee",
    walletSettlementDate: "Settlement Date",
    walletPaymentStatus: "Payout Status",
    walletPaid: "Paid",
    walletUnpaid: "Unpaid",
    walletNoDetails: "No settlement details yet",
    scoreDetailsTitle: "Score Details",
    scoreNoDetails: "No score details yet",
    scoreOldNew: "Score Change",
    scoreAdjustment: "Score Adjustment",
    scoreEventTypes: {
      order_completed_bonus: "Completion Bonus",
      driver_complaint_penalty: "Complaint Deduction",
      completed_bonus_reversed_by_complaint: "Completion Bonus Reversed",
      driver_complaint_reversed: "Complaint Reversed",
      completed_bonus_restored_after_complaint_reverse: "Completion Bonus Restored",
      order_return_penalty: "Order Return Penalty",
    },
    currentMonthSettlementAmount: "Current Month Settlement",
    nextMonthSettlementAmount: "Next Month Settlement",
    driverSettlementRule: "Orders from the 1st to month-end are settled on the 15th of the next month",
    canAcceptOrders: "Can accept orders",
    cannotAcceptOrders: "Order acceptance disabled",
    onboardingTitle: "Onboarding Checklist",
    businessStartCheck: "Complete all items to start accepting orders",
    businessStartCheckHint: "Finish personal info, vehicle info, training, and inspection in order",
    documentManagement: "Profile / Documents",
    documentManagementTitle: "Profile & Document Management",
    documentManagementHint: "License, inspection, insurance, residence card/Japanese nationality, bank account",
    personalDocumentsTitle: "Personal Info / Documents",
    personalDocumentsHint: "License, residence card, contact info",
    vehicleDocumentsTitle: "Vehicle Documents",
    vehicleDocumentsHint: "Inspection certificate, insurance, vehicle photos",
    payoutAccountTitle: "Payout Account",
    payoutAccountHint: "Bank account and settlement info",
    documentExpired: "Expired document found",
    documentExpiredCount: "expired item(s)",
    documentExpiredAutoPause: "New order acceptance is automatically paused while documents are expired.",
    documentExpiringSoon: (count) => `${count} document(s) will expire within 30 days. Please update them early.`,
    documentSaved: "Documents saved",
    needsCompletion: "Incomplete",
    driverLicenseInfo: "Driver License Info",
    vehicleInspectionDocument: "Vehicle Inspection Certificate",
    vehicleInspectionExpiry: "Inspection expiry",
    optionalInsurance: "Voluntary Insurance",
    optionalInsuranceCompany: "Insurance company",
    optionalInsurancePolicyNumber: "Insurance policy number",
    optionalInsuranceExpiry: "Insurance expiry",
    optionalInsuranceFront: "Insurance front",
    optionalInsuranceBack: "Insurance back",
    residenceOrPassport: "Residence Card / Japanese Nationality",
    residenceCardNumber: "Residence card number",
    japaneseNational: "Japanese nationality",
    validUntil: "Valid until",
    longTermValid: "Long-term valid",
    bankAccount: "Bank Account",
    bankName: "Bank name",
    bankBranch: "Branch",
    bankAccountType: "Account type",
    bankAccountTypeOptions: [{ value: "", label: "Select" }, { value: "普通", label: "Ordinary" }, { value: "当座", label: "Current" }],
    bankAccountNumber: "Account number",
    bankAccountHolder: "Account holder",
    saveDocuments: "Save Documents",
    onboardingSubmitted: "Submitted. Waiting for admin review.",
    trainingPassed: "Training test passed",
    personalInfo: "Personal Info",
    fullName: "Full name",
    dateOfBirth: "Date of birth",
    address: "Address",
    driverServiceLanguages: "Driver service languages",
    driverServiceLanguageNames: {
      ja: "Japanese",
      en: "English",
      es: "Spanish",
      ko: "Korean",
      zh: "Chinese",
    },
    chooseFromAlbum: "Choose from album",
    takeProfilePhoto: "Take photo",
    openAlbumOrChooseFile: "Choose file",
    noFileSelected: "No file selected",
    fileSelected: "Selected",
    onboardingMissingFields: "Complete the following required items",
    onboardingFileTooLarge: "The file is too large. Take another photo or choose a smaller file.",
    onboardingFileReadFailed: "The file could not be read. Please choose it again.",
    residenceCardExpiry: "Residence card expiry",
    driverLicenseNumber: "Driver license number",
    driverLicenseExpiry: "Driver license expiry",
    residenceCardFront: "Residence card front",
    residenceCardBack: "Residence card back",
    driverLicenseFront: "License front",
    driverLicenseBack: "License back",
    plateRegion: "Region",
    plateClass: "Class number",
    plateKana: "Kana",
    plateDigits: "Plate number",
    vehicleModel: "Vehicle model",
    vehicleModelOptions: [{ value: "alphard", label: "Alphard" }, { value: "hiace", label: "Hiace" }],
    vehicleColor: "Vehicle color",
    vehicleColorOptions: [{ value: "black", label: "Black" }],
    vehicleYear: "Vehicle year (2016+)",
    inspectionCertificate: "Vehicle inspection certificate",
    recordCertificate: "Record certificate",
    optionalInsurancePhoto: "Insurance photo",
    compulsoryInsuranceExpiry: "Compulsory insurance expiry",
    compulsoryInsurancePhoto: "Compulsory insurance photo",
    training: "Pre-Service Training",
    submitTraining: "Submit Test",
    trainingLessonProgress: "Lesson",
    trainingMaterial: "Learning material",
    trainingUnderstandPage: "I understand this page",
    trainingConfirmed: "Confirmed",
    trainingNext: "Next",
    trainingPrev: "Back",
    trainingStartTest: "Start test",
    trainingLocked: "Confirm every learning page to unlock the training test.",
    trainingWrongHint: "Some answers are incorrect. Review the linked learning pages and try again.",
    trainingCritical: "Important",
    vehicleInspection: "Inspection / Label",
    inspectionLocation: "Inspection location",
    inspectionCompleted: "Vehicle inspection completed",
    labelAttached: "Label attached",
    inspectionSite: "Designated Site",
    inspectionAddressPending: "The site address will be provided by admin.",
    inspectionFutureSelectable: "Only one site is available now. More choices can be added later.",
    appointmentDate: "Appointment Date",
    appointmentTime: "Appointment Time (30 min)",
    inspectionNoticeTitle: "Confirmation Items",
    inspectionFeeWarning: "JPY 5,000 pays for an in-person vehicle inspection and a physical Big Taxi company label. It does not purchase digital features or access to the app. If the vehicle or attire fails the on-site inspection standards, this physical-service fee is non-refundable.",
    confirmInspectionAppointment: "Confirm Appointment",
    inspectionPaymentStep: "Vehicle Inspection Fee",
    payInspectionFee: "Pay In-Person Inspection & Physical Label Fee",
    inspectionQrTitle: "Inspection Code",
    inspectionQrHint: "After payment, save this QR code and 8-digit code for the inspection site.",
    inspectionPaymentStatus: "Payment Status",
    paymentSetupRequired: "Square payment is not configured yet",
    paymentLinkFailed: "The payment screen could not be prepared. Please try again.",
    inspectionPaymentStatusLabels: { pending: "Unpaid", created: "Awaiting Payment", payment_setup_required: "Payment Setup Required", payment_link_failed: "Payment Setup Failed", paid: "Paid", completed: "Paid", canceled: "Canceled", cancelled: "Canceled", failed: "Payment Failed" },
    squareTrust: "Your card information is processed securely by Square and is not stored by us.",
    pending: "Pending",
    onboardingStatus: { pending: "Pending", submitted: "Reviewing", approved: "Done", rejected: "Rejected" },
    auditStatus: "Review Status",
    rejectionReason: "Rejection Reason",
    onboardingAuditStates: { pending_submission: "Pending Submission", reviewing: "Under Review", needs_changes: "Needs Changes", approved: "Approved" },
    onboardingItemStatus: { to_complete: "To Complete", reviewing: "Under Review", needs_changes: "Needs Changes", completed: "Approved", incomplete: "Incomplete", not_started: "Not Started" },
    onboardingSteps: { personal_info: "Personal Info", vehicle_info: "Vehicle Info", training: "Training", vehicle_inspection: "Inspection / Label", final_review: "Final Review" },
    settings: "Settings",
    fleetJoinTitle: "Join a Fleet",
    fleetJoinHint: "Enter the permanent fleet code shared by the fleet manager to join an approved fleet.",
    fleetCodePlaceholder: "Enter fleet code",
    fleetJoin: "Join",
    fleetJoining: "Joining…",
    fleetJoinSuccess: "You have joined the fleet.",
    fleetJoinFailed: "Unable to join the fleet. Please check the fleet code and try again.",
    fleetMembershipLabel: "Fleet",
    fleetMembershipTitle: "Your Fleet",
    fleetMembershipUnknown: "Checking fleet information",
    fleetMembershipHint: "This is the fleet you currently belong to.",
    fleetExitRequest: "Request to Leave Fleet",
    fleetExitRequestHint: "Submit your reason for the fleet manager to review. After approval, you can join another fleet.",
    fleetExitReasonPlaceholder: "Tell the fleet manager why you want to leave",
    fleetExitSubmitting: "Submitting…",
    fleetExitRequestPending: "Your request is waiting for the fleet manager's approval.",
    fleetExitRequestSuccess: "Your request was submitted. Please wait for the fleet manager's approval.",
    fleetExitRequestFailed: "Unable to submit your request. Please try again.",
    fleetManagementTitle: "Fleet Management",
    fleetManagementHint: "Manage dispatches, driver accounts, and fleet settings.",
    fleetMasterAccount: "Fleet Master Account",
    fleetDrivers: "Drivers",
    fleetVehicles: "Vehicles",
    fleetDispatchableOrders: "Ready to Dispatch",
    timeOff: "Request Leave",
    upcoming: "Upcoming",
    completed: "Completed",
    goComplete: "Complete",
    all: "All",
    add: "Add",
    refresh: "Refresh",
    official: "Official",
    unreadMessage: "New",
    noOrders: "No orders",
    unknownCustomer: "Unknown customer",
    downloadPdf: "PDF",
    downloading: "Loading...",
    addToCalendar: "Add Calendar",
    addedToCalendar: "Added to Calendar",
    calendarDateMissing: "Order date is missing. Cannot add to calendar.",
    calendarPermissionDenied: "Please allow calendar access in iPhone Settings.",
    calendarNativeUnavailable: "Calendar is not ready. Please restart the app.",
    reportedAt: "Reported",
    reportDuration: "Report Time",
    dispatchPrice: "Dispatch Price",
    fleetAssignedDriver: "Assigned driver",
    fleetUnassigned: "Unassigned",
    fleetAssignDriver: "Assign driver",
    fleetReassignDriver: "Change driver",
    fleetChooseDriver: "Choose a driver",
    fleetChooseVehicle: "Choose a vehicle",
    fleetSelectedDriver: "Selected driver",
    fleetAssignedVehicle: "Assigned vehicle",
    fleetAssignVehicle: "Use this vehicle",
    fleetNoSavedVehicles: "No saved vehicles yet. Add one with the button above.",
    fleetAddVehicle: "Add a new vehicle",
    fleetVehicleType: "Vehicle type",
    fleetPlateNumber: "License plate",
    fleetPlatePlaceholder: "Example: Shinagawa 500 A 1234",
    fleetVehicleSaveHint: "It will be saved, assigned to this order, and available to select next time.",
    fleetSaveAndAssign: "Save and assign",
    fleetDeleteVehicle: "Delete",
    fleetVehicleDeleted: "Vehicle removed from saved list",
    change: "Change",
    vehicle: "Vehicle",
    fleetAssigning: "Assigning...",
    fleetAssignmentLocked: "Driver reassignment is locked after service starts",
    fleetNoAvailableDrivers: "No available fleet drivers",
    fleetOrderReadOnly: "This is a fleet-owned order. Only the assigned driver can update the service status.",
    orderDetail: "Order Detail",
    back: "Back",
    orderStatus: "Order Status",
    booking: "Booking",
    service: "Service",
    driver: "Driver",
    statusActions: "Status Action",
    chooseIssue: "Select Issue",
    issuePlaceholder: "Describe the issue",
    submitIssue: "Submit Issue",
    dateTime: "Date & Time",
    charterDuration: "Charter Duration",
    hours: "hours",
    dispatchContact: "Dispatch Contact",
    dispatchNote: "Dispatch Note",
    tripInfo: "Trip Info",
    terminal: "Terminal",
    flightNumber: "Flight / Ferry No.",
    passengerInfo: "Passenger Info",
    passengerName: "Passenger Name",
    customerCode: "Customer Code",
    phone: "Phone",
    passengerCount: "Passengers",
    luggageCount: "Luggage",
    childSeats: "Child Seats",
    peopleUnit: "pax",
    luggageUnit: "pcs",
    vehicleInfo: "Vehicle Info",
    vehicleType: "Vehicle",
    plateNumber: "Plate",
    brand: "Brand",
    extraServices: "Extra Services",
    notes: "Notes",
    reportCharterTime: "Report Charter Time",
    reportedEndTime: "Reported End Time",
    modifyEndTime: "Modify End Time",
    reportEndTime: "Report Charter End Time",
    orderNo: "Order No.",
    startTime: "Start Time",
    bookedDuration: "Booked Duration",
    actualEndTime: "Actual End Time (30 min)",
    submit: "Submit",
    editExtraOrder: "Edit",
    submitConfirm: "Confirm",
    submitting: "Submitting...",
    selectEndTime: "Select end time",
    enterChat: "Enter Chat",
    unreadEnterChat: "New message",
    tripCommunicationCenter: "Trip Communication Center",
    driverSections: "Driver sections",
    route: "Route",
    changePassword: "Change Password",
    faceIdLogin: "Sign in with Face ID",
    faceIdLoginHint: "Use saved account and password for faster sign-in next time",
    faceIdChecking: "Checking Face ID...",
    faceIdEnabled: "Face ID sign-in enabled",
    faceIdDisabled: "Face ID sign-in disabled",
    faceIdUnavailable: "Face ID is not available on this device",
    faceIdCredentialRequired: "Log out once, select Remember account on the login screen, then enable Face ID again",
    faceIdAuthFailed: "Face ID did not start. Check Face ID settings on this device and try again",
    loginWithFaceId: "Sign in with Face ID",
    faceIdReason: "Authenticate with Face ID to sign in to Big Taxi Driver",
    emergencyContact: "Emergency Support",
    emergencyContactHint: "Use this during service for urgent issues or trouble",
    contactDispatch: "Contact Dispatch",
    onlineBigTaxiSupport: "Contact Dispatch Center Online",
    phoneBigTaxiSupport: "Call Dispatch Center",
    customerServicePhoneNumber: "Customer service phone number",
    callBigTaxiSupportPrompt: "Call Dispatch Center now",
    callNow: "Call",
    close: "Close",
    reportAccidentTrouble: "Accident / Trouble Report",
    openOrderDetailToReport: "Report from order detail",
    legalComplianceCenter: "Legal & Compliance Center",
    legalComplianceCenterHint: "Review important terms, privacy, location, and notification information",
    termsOfUse: "Terms of Use",
    privacyPolicy: "Privacy Policy",
    viewFullPrivacyPolicy: "Open Full Privacy Policy",
    privacyPolicyBody: "Big Taxi Driver uses personal information only for driver account management, dispatch operations, identity checks, settlement, emergency handling, quality control, and compliance.\n\nInformation may include name, contact details, identity documents, vehicle records, bank account details, login device data, and app activity records.\n\nInformation may be shared with dispatch staff, administrators, payment providers, verification providers, and system vendors only when necessary for operations, safety, or legal compliance.",
    locationInformation: "Location Information",
    locationInformationBody: "Location data is used to record order status updates, confirm arrival and service progress, support emergency response, and provide an operational record if a problem occurs.\n\nWhen a driver updates a status, the time and location may be saved to the order history and shown to administrators. The purpose is dispatch accuracy and safety, not unnecessary monitoring.\n\nIf location permission is disabled, some status updates, evidence records, and emergency support functions may not work correctly.",
    notificationInformation: "Notifications",
    notificationInformationBody: "Notifications are used for new orders, order changes, cancellations, dispatch messages, passenger messages, and urgent contact.\n\nLock screen notifications are kept short. Sensitive details such as full phone numbers, hotel room numbers, and detailed private information are not shown in the notification body.\n\nIf notifications are disabled, important schedule changes or urgent messages may be missed.",
    safeDrivingGuide: "Safe Driving Guide",
    safeDrivingGuideBody: "Drivers must follow traffic laws and put safety first. Speeding, harsh driving, distracted driving, and driving while unwell are prohibited.\n\nVehicles must be kept clean and prepared according to company standards, including water, signage, vehicle condition, and driver attire where required.\n\nFor accidents, delays, passenger trouble, lost property, or vehicle problems, contact dispatch promptly and do not make compensation or refund decisions alone.",
    emergencyResponse: "Emergency Response",
    emergencyResponseBody: "For injury, accident, sudden illness, vehicle breakdown, or serious passenger trouble, secure safety first and contact police, fire, or ambulance services when needed.\n\nThen report the situation to dispatch through the app or emergency contact, including location, order number, and passenger safety status.\n\nDo not make promises about refunds, compensation, or liability at the scene without administrator approval.",
    accountSuspensionScoreRules: "Account Suspension & Score Rules",
    accountSuspensionScoreRulesBody: "Driver score is updated based on completion rate, cancellations, delays, complaints, vehicle and attire standards, communication, and issue reports.\n\nOrder acceptance may be suspended for serious rule violations, false reports, unauthorized cancellations, unsafe driving, improper handling of personal information, repeated complaints, or expired documents.\n\nIf the score falls below the required level or required documents expire, the driver may still view existing orders, but new order acceptance will be blocked.",
    deviceManagement: "Device Management",
    loginDeviceManagement: "Login Device Management",
    loginDeviceManagementHint: "View and remove devices signed in to this account",
    loginDevicesEmpty: "No login devices found",
    currentDevice: "Current Device",
    lastLoginAt: "Last login",
    removeDevice: "Remove",
    removingDevice: "Removing...",
    loginDeviceRemoved: "Login device removed",
    loginDeviceLoadFailed: "Could not load login devices",
    loginDeviceRemoveFailed: "Could not remove this device",
    aboutApp: "App Information",
    versionNumber: "Driver App",
    notificationSettings: "Notification Settings",
    languageSettings: "Language Settings",
    languageSettingsHint: "Change the display language of the app",
    languageSaved: "Display language updated",
    driverNoticeTitle: "Notice",
    driverNoticeHistory: "Notice",
    driverNoticeEmpty: "No notices yet",
    importantNotificationTitle: "Important Notice",
    importantNotificationAck: "Confirmed",
    importantNotificationOpenOrder: "Open Order",
    importantNotificationCreatedAt: "Created",
    importantNotificationPending: "Pending",
    importantNotificationSaving: "Saving…",
    importantNotificationFailed: "Confirmation response not received. Retry or check later; it may already be saved.",
    importantNotificationLater: "Review later (keep unread)",
    orderChangeUpdated: "Updated",
    orderChangeTime: "Time",
    orderChangePickup: "Pick-up",
    orderChangeDropoff: "Drop-off",
    orderChangeNote: "Note",
    orderChangeCancelled: "Cancelled",
    newReservationNotification: "New Reservation Notifications",
    reservationChangeNotification: "Reservation Change Notifications",
    urgentContactNotification: "Urgent Contact Notifications",
    notificationSettingsSaved: "Notification settings saved",
    logout: "Log Out",
    driverAppVersion: "2.0",
    firstLoginChangePassword: "Change Password First",
    currentPassword: "Current Password",
    newPassword: "New Password",
    confirmNewPassword: "Confirm New Password",
    currentPasswordPlaceholder: "Enter current password",
    newPasswordPlaceholder: "At least 6 characters",
    confirmPasswordPlaceholder: "Enter new password again",
    passwordTooShort: "New password must be at least 6 characters",
    passwordMismatch: "Passwords do not match",
    passwordChanged: "Password changed",
    systemConfigError: "System configuration error. Contact admin.",
    passwordChangeFailed: "Failed to change password",
    timeOffRequest: "Time Off Request",
    timeOffHint: "Visible to dispatch immediately after submission",
    startDate: "Start Date",
    endDate: "End Date",
    allDayRange: "All-day / Date range",
    endTime: "End Time",
    reason: "Note",
    reasonPlaceholder: "e.g. Personal, hospital, family schedule",
    submitTimeOff: "Submit Time Off",
    myTimeOffRecords: "My Time Off",
    noTimeOffRecords: "No time off records",
    cancelled: "Cancelled",
    active: "Active",
    timeOffRegistered: "Time off registered",
    getTimeOffFailed: "Failed to get time off records",
    submitFailed: "Submit failed",
    cancelFailed: "Cancel failed",
    chooseStartDate: "Select start date",
    chooseStartEndTime: "Select start and end time",
    confirmCancelTimeOff: "Cancel this time off record?",
    fullDay: "All day",
    loginExpired: "Login expired. Please log in again",
    accountDisabled: "Account disabled. Contact admin",
    orderFetchFailed: "Failed to get orders",
    unknownError: "Unknown error",
    unknownStatus: "Status unavailable",
    networkError: "Network error. Check your connection",
    reportSuccess: "Reported",
    reportFailed: "Report failed",
    cancelExtraConfirm: "Cancel this extra schedule?",
    extraServiceTypes: {
      airport_sign: "Airport signboard",
      infant_seat: "Infant seat",
      airport_pickup_sign: "Airport signboard",
      hotel_sign: "Hotel signboard",
      english_driver: "English-speaking driver",
      tokyo_station_platform: "Tokyo Station platform assist",
      platform_dropoff: "Station platform assist",
      tokyo_station_sign: "Tokyo Station signboard",
      odawara_station_sign: "Odawara Station signboard",
      shinkansen_ticket: "Shinkansen ticket support",
      hiace_14_seat_upgrade: "Upgrade to 14-seat Hiace",
      fuji_5th_station: "Mt. Fuji 5th Station add-on",
      child_seat: "Child seat",
      extended_waiting_time: "Extended waiting time",
      other: "Other service",
    },
    openMap: "Check Map",
    mapConfirm: "Map Confirmation",
    pickup: "Pickup",
    dropoff: "Dropoff",
    appleMaps: "Apple Maps",
    googleMaps: "Google Maps",
    startNavigation: "Open Navigation",
    cancel: "Cancel",
    retryPending: "Retrying pending status updates",
    statusUpdated: "Status updated",
    statusQueued: "Network is unstable. Status saved and will sync automatically.",
    statusSyncing: "Syncing pending status update",
    statusSynced: "Pending status update synced",
    statusPendingCount: "Pending status updates",
    issueReport: "Report Issue",
    cancelIssueReport: "Cancel Issue Report",
    issueReportCancelled: "Issue report cancelled",
    returnOrder: "Return Order",
    returnOrderTitle: "Return reason",
    returnOrderPlaceholder: "Optional reason",
    returnOrderSwipe: "Return to Order Pool",
    returnOrderConfirm: "Return this order to the pool?",
    returnOrderSuccess: "Order returned",
    returnOrderFailed: "Failed to return order",
    swipeToConfirm: "Slide right",
    pleaseWait: "Please wait",
    status: {
      pending: "Pending",
      pending_confirmation: "Pending",
      confirmed: "Confirmed",
      completed: "Completed",
      cancelled: "Cancelled",
    },
    driverStatus: {
      assigned: "Pending",
      confirmed: "Confirmed",
      driver_departed: "Departed",
      arrived_pickup: "Arrived",
      passenger_onboard: "Onboard",
      in_service: "In Service",
      completed: "Completed",
      issue_reported: "Issue Reported",
    },
    driverActions: {
      confirmed: "Confirm Order",
      driver_departed: "Depart",
      arrived_pickup: "Arrived at Pickup",
      passenger_onboard: "Passenger Onboard",
      in_service: "Start Service",
      completed: "Complete Service",
    },
    serviceType: {
      transfer: "Transfer",
      charter: "Charter",
    },
    issueOptions: {
      unable_contact_passenger: "Cannot contact passenger",
      passenger_no_show: "Passenger no-show",
      passenger_late: "Passenger late",
      flight_or_train_delay: "Flight / train delay",
      pickup_location_problem: "Pickup location unclear",
      route_or_destination_changed: "Route / destination changed",
      extra_waiting_time: "Extra waiting required",
      luggage_or_item_left: "Lost item",
      vehicle_or_traffic_issue: "Vehicle / traffic issue",
      order_information_problem: "Order information issue",
      other: "Other",
    },
  },
  zh_cn: {
    loading: "加载中...",
    cachedData: "当前为缓存数据",
    offlineOrderPackReady: (count) => `未来48小时已离线保存 ${count} 个订单`,
    offlineSignboardReady: (count) => `举牌PDF ${count} 份`,
    offlineSignboardUnavailable: "此订单的举牌 PDF 尚未缓存，请联网后在我的订单刷新一次。",
    nextOrder: "下一单",
    myOrders: "我的订单",
    conversations: "对话",
    conversationListHint: "聊天室开启后显示在进行中，订单开始24小时后移入已完成",
    activeConversations: "进行中",
    completedConversations: "已完成",
    noActiveConversations: "暂无进行中的订单对话",
    noCompletedConversations: "暂无已完成的订单对话",
    noConversations: "暂无可用的订单对话",
    myPage: "我的主页",
    myPageTab: "我",
    profilePhotoMenuTitle: "更换头像",
    chooseFromAlbum: "从相册选择",
    takeProfilePhoto: "拍照",
    orderPool: "订单池",
    poolOrders: "订单池",
    applyOrder: "申请接单",
    applyingOrder: "提交中...",
    cancelApplication: "撤销申请",
    applicationPending: "已申请",
    applySuccess: "接单成功",
    poolDisabled: "当前不能接新订单",
    orderPoolOnboardingRequired: "完成上岗资料审查即可接单",
    orderPoolExpiredDocumentRequired: (name) => `${name}资料已过期，请更新后再接单`,
    orderPoolTemporarilyUnavailable: "当前暂时不能接单",
    documentExpiryNames: { driver_license: "驾照", residence_card: "在留卡", passport: "护照", vehicle_inspection: "车检证", optional_insurance: "任意保险" },
    noPoolOrders: "暂无可接订单\n有新订单时会第一时间通知你\n请保持 App 通知开启",
    poolDecisionHint: "订单发布后30分钟内，系统将优先分配给积分较高的司机",
    dispatchPriceLabel: "派单价",
    driverScore: "当前积分",
    driverScoreHint: "根据完成率、取消和投诉情况自动更新",
    monthlyRevenueTitle: "本月売上 / 报酬",
    monthlyCompletedOrders: "本月完成件数",
    monthlyReward: "本月报酬",
    monthlyUnsettled: "未精算",
    myWallet: "我的钱包",
    settlement: "结算",
    viewDetails: "查看明细",
    walletDetailsTitle: "结算明细",
    walletOrderAmount: "订单金额",
    walletOvertimeFee: "超时费",
    walletSettlementDate: "结算日期",
    walletPaymentStatus: "打款状态",
    walletPaid: "已打款",
    walletUnpaid: "未打款",
    walletNoDetails: "暂无结算明细",
    scoreDetailsTitle: "积分明细",
    scoreNoDetails: "暂无积分明细",
    scoreOldNew: "积分变化",
    scoreAdjustment: "积分调整",
    scoreEventTypes: {
      order_completed_bonus: "完成订单奖励",
      driver_complaint_penalty: "投诉扣分",
      completed_bonus_reversed_by_complaint: "投诉成立撤回完成奖励",
      driver_complaint_reversed: "投诉撤销返还扣分",
      completed_bonus_restored_after_complaint_reverse: "投诉撤销恢复完成奖励",
      order_return_penalty: "退回订单扣分",
    },
    currentMonthSettlementAmount: "当月结算金额",
    nextMonthSettlementAmount: "次月结算金额",
    driverSettlementRule: "1日至月末的订单，在次月15日结算",
    canAcceptOrders: "可以接新订单",
    cannotAcceptOrders: "禁止接新订单",
    onboardingTitle: "上岗资料审核",
    businessStartCheck: "所有项目全部完成后可以开始接单",
    businessStartCheckHint: "请依次完成个人信息、车辆信息、培训和整备场检查",
    documentManagement: "资料 / 证件管理",
    documentManagementTitle: "司机资料 / 证件管理",
    documentManagementHint: "驾照、车检证、保险、在留卡/日本国籍、银行账户",
    personalDocumentsTitle: "个人资料 / 证件",
    personalDocumentsHint: "驾照、在留卡、联系方式",
    vehicleDocumentsTitle: "车辆资料",
    vehicleDocumentsHint: "车检证、保险、车辆照片",
    payoutAccountTitle: "收款账户",
    payoutAccountHint: "银行账户、结算信息",
    documentExpired: "有资料已经过期",
    documentExpiredCount: "项过期",
    documentExpiredAutoPause: "资料过期后，新订单接单功能会自动暂停。",
    documentExpiringSoon: (count) => `${count}项资料将在30天内到期，请尽早更新。`,
    documentSaved: "资料已保存",
    needsCompletion: "待完善",
    driverLicenseInfo: "驾照信息",
    vehicleInspectionDocument: "车检证",
    vehicleInspectionExpiry: "车检证到期日",
    optionalInsurance: "任意保险",
    optionalInsuranceCompany: "保险公司名称",
    optionalInsurancePolicyNumber: "保险证券号",
    optionalInsuranceExpiry: "任意保险到期日",
    optionalInsuranceFront: "任意保险正面",
    optionalInsuranceBack: "任意保险反面",
    residenceOrPassport: "在留卡 / 日本国籍",
    residenceCardNumber: "在留卡编号",
    japaneseNational: "日本国籍",
    validUntil: "有效期限至",
    longTermValid: "长期有效",
    bankAccount: "银行账户",
    bankName: "银行名",
    bankBranch: "支店名",
    bankAccountType: "账户类型",
    bankAccountTypeOptions: [{ value: "", label: "请选择" }, { value: "普通", label: "普通" }, { value: "当座", label: "当座" }],
    bankAccountNumber: "账户号码",
    bankAccountHolder: "账户名义",
    saveDocuments: "保存资料",
    onboardingSubmitted: "已提交，等待后台审核",
    trainingPassed: "培训测试已通过",
    personalInfo: "个人信息",
    fullName: "姓名",
    dateOfBirth: "出生日期",
    address: "住址",
    driverServiceLanguages: "司机可服务语言",
    driverServiceLanguageNames: {
      ja: "日语",
      en: "英语",
      es: "西班牙语",
      ko: "韩语",
      zh: "中文",
    },
    chooseFromAlbum: "从相册选择",
    takeProfilePhoto: "拍照",
    openAlbumOrChooseFile: "打开相册/选择文件",
    noFileSelected: "未选择文件",
    fileSelected: "已选择",
    onboardingMissingFields: "请补充以下必填资料",
    onboardingFileTooLarge: "文件仍然过大，请重新拍照或选择较小的文件。",
    onboardingFileReadFailed: "无法读取文件，请重新选择。",
    residenceCardNumber: "在留卡编号",
    residenceCardExpiry: "在留卡期限",
    driverLicenseNumber: "驾照编号",
    driverLicenseExpiry: "驾照到期日期",
    residenceCardFront: "在留卡正面",
    residenceCardBack: "在留卡反面",
    driverLicenseFront: "驾照正面",
    driverLicenseBack: "驾照反面",
    plateRegion: "管辖地名",
    plateClass: "分类番号",
    plateKana: "平假名",
    plateDigits: "一连指定番号",
    vehicleModel: "车辆型号",
    vehicleModelOptions: [{ value: "alphard", label: "阿尔法" }, { value: "hiace", label: "海狮" }],
    vehicleColor: "车辆颜色",
    vehicleColorOptions: [{ value: "black", label: "黑色" }],
    vehicleYear: "年式（2016年之后）",
    inspectionCertificate: "车检证",
    recordCertificate: "记录事项书",
    optionalInsurancePhoto: "任意保险照片",
    compulsoryInsuranceExpiry: "自賠責有效期",
    compulsoryInsurancePhoto: "自賠責照片",
    training: "上岗前培训",
    submitTraining: "提交测试",
    trainingLessonProgress: "学习",
    trainingMaterial: "学习资料",
    trainingUnderstandPage: "我已理解本页内容",
    trainingConfirmed: "已确认",
    trainingNext: "下一页",
    trainingPrev: "上一页",
    trainingStartTest: "进入测试",
    trainingLocked: "确认全部学习资料后，才能进入培训测试。",
    trainingWrongHint: "有题目未答对。请回到对应学习资料复习后再提交。",
    trainingCritical: "重点提醒",
    vehicleInspection: "整备场检查 / 贴标",
    inspectionLocation: "整备场名称",
    inspectionCompleted: "已完成车辆检查",
    labelAttached: "已完成贴标",
    inspectionSite: "指定整备场",
    inspectionAddressPending: "整备场地址由管理员通知",
    inspectionFutureSelectable: "整备场可根据后台配置选择。",
    appointmentDate: "预约日期",
    appointmentTime: "预约时间（30分钟单位）",
    inspectionNoticeTitle: "确认事项",
    inspectionFeeWarning: "JPY 5,000 用于线下现场车辆检查和实体 Big Taxi 公司贴标，不用于购买数字功能或 App 使用资格。如果车辆或着装未通过现场检查标准，该线下服务费用不退。",
    confirmInspectionAppointment: "确认预约内容",
    inspectionPaymentStep: "车辆检查费用",
    payInspectionFee: "支付线下车辆检查和实体贴标费用",
    inspectionQrTitle: "整备场核销码",
    inspectionQrHint: "付款后请保存二维码和8位数核销码，到整备场出示。",
    inspectionPaymentStatus: "付款状态",
    paymentSetupRequired: "Square 付款配置未完成",
    paymentLinkFailed: "付款页面准备失败，请重试。",
    inspectionPaymentStatusLabels: { pending: "未付款", created: "等待付款", payment_setup_required: "等待配置付款", payment_link_failed: "付款准备失败", paid: "已付款", completed: "已付款", canceled: "已取消", cancelled: "已取消", failed: "付款失败" },
    squareTrust: "银行卡信息由 Square 安全处理，本系统不会保存卡号。",
    pending: "未完成",
    onboardingStatus: { pending: "未完成", submitted: "待审核", approved: "已完成", rejected: "已退回" },
    auditStatus: "审核状态",
    rejectionReason: "驳回原因",
    onboardingAuditStates: { pending_submission: "待提交", reviewing: "审核中", needs_changes: "需修改", approved: "已通过" },
    onboardingItemStatus: { to_complete: "待完善", reviewing: "审核中", needs_changes: "需修改", completed: "已通过", incomplete: "未完成", not_started: "未开始" },
    onboardingSteps: { personal_info: "个人信息", vehicle_info: "车辆信息", training: "上岗前培训", vehicle_inspection: "整备场检查/贴标", final_review: "最终审核" },
    settings: "设置",
    fleetJoinTitle: "加入车队",
    fleetJoinHint: "如需加入已开通车队，请输入负责人提供的永久车队码。",
    fleetCodePlaceholder: "请输入车队码",
    fleetJoin: "加入",
    fleetJoining: "加入中…",
    fleetJoinSuccess: "已加入车队",
    fleetJoinFailed: "加入车队失败，请确认车队码后重试。",
    fleetMembershipLabel: "所属车队",
    fleetMembershipTitle: "所属车队",
    fleetMembershipUnknown: "正在确认车队信息",
    fleetMembershipHint: "这是你当前所属的车队。",
    fleetExitRequest: "申请退出车队",
    fleetExitRequestHint: "填写理由并递交后，由车队主账号审核。审核通过后可加入其他车队。",
    fleetExitReasonPlaceholder: "请填写申请退出的原因",
    fleetExitSubmitting: "递交中…",
    fleetExitRequestPending: "退出申请已递交，等待车队主账号审核",
    fleetExitRequestSuccess: "退出申请已递交，等待车队主账号审核。",
    fleetExitRequestFailed: "退出申请递交失败，请稍后重试。",
    fleetManagementTitle: "车队管理",
    fleetManagementHint: "管理配车、司机账号和车队设置。",
    fleetMasterAccount: "车队主账号",
    fleetDrivers: "司机",
    fleetVehicles: "车辆",
    fleetDispatchableOrders: "可派订单",
    timeOff: "请假申请",
    upcoming: "即将出发",
    completed: "已完成",
    goComplete: "去完成",
    all: "全部",
    add: "追加",
    refresh: "刷新",
    official: "正式",
    unreadMessage: "新消息",
    noOrders: "暂无订单",
    unknownCustomer: "未知客户",
    downloadPdf: "下载 PDF",
    downloading: "下载中...",
    addToCalendar: "添加到日历",
    addedToCalendar: "已添加到日历",
    calendarDateMissing: "订单日期缺失，无法添加到日历",
    calendarPermissionDenied: "请在 iPhone 设置里允许日历权限",
    calendarNativeUnavailable: "日历功能未准备好，请重新打开 App",
    reportedAt: "已汇报",
    reportDuration: "汇报时长",
    dispatchPrice: "派单价格",
    fleetAssignedDriver: "实际司机",
    fleetUnassigned: "待指派",
    fleetAssignDriver: "指派司机",
    fleetReassignDriver: "改派司机",
    fleetChooseDriver: "选择司机",
    fleetChooseVehicle: "选择车辆",
    fleetSelectedDriver: "已选择司机",
    fleetAssignedVehicle: "实际车辆",
    fleetAssignVehicle: "指定此车辆",
    fleetNoSavedVehicles: "暂无已保存车辆，请点击上方按钮直接添加",
    fleetAddVehicle: "直接添加车辆",
    fleetVehicleType: "车型",
    fleetPlateNumber: "车牌号",
    fleetPlatePlaceholder: "例如：东京 500 1234",
    fleetVehicleSaveHint: "保存后会立即指定给本订单，以后可直接从列表选择。",
    fleetSaveAndAssign: "保存并指定",
    fleetDeleteVehicle: "删除",
    fleetVehicleDeleted: "车辆已从保存列表删除",
    change: "更换",
    vehicle: "车辆",
    fleetAssigning: "指派中...",
    fleetAssignmentLocked: "服务开始后不能改派",
    fleetNoAvailableDrivers: "暂无可指派的车队司机",
    fleetOrderReadOnly: "这是车队所属订单，仅实际被指派的司机可以更新服务状态。",
    orderDetail: "订单详情",
    back: "返回",
    orderStatus: "订单状态",
    booking: "预约",
    service: "服务",
    driver: "司机",
    statusActions: "订单状态操作",
    chooseIssue: "选择异常项目",
    issuePlaceholder: "手动输入问题说明",
    submitIssue: "提交异常",
    dateTime: "日期时间",
    charterDuration: "包车时长",
    hours: "小时",
    dispatchContact: "调度联系",
    dispatchNote: "调度备注",
    tripInfo: "行程信息",
    terminal: "航站楼",
    flightNumber: "航班/船班号",
    passengerInfo: "乘客信息",
    passengerName: "乘客姓名",
    customerCode: "客户代码",
    phone: "联系电话",
    passengerCount: "乘客人数",
    luggageCount: "行李数量",
    childSeats: "儿童座椅",
    peopleUnit: "人",
    luggageUnit: "件",
    vehicleInfo: "车辆信息",
    vehicleType: "车型",
    plateNumber: "车牌号",
    brand: "品牌",
    extraServices: "额外服务",
    notes: "备注",
    reportCharterTime: "汇报包车时间",
    reportedEndTime: "已汇报结束时间",
    modifyEndTime: "修改结束时间",
    reportEndTime: "汇报包车结束时间",
    orderNo: "订单号",
    startTime: "开始时间",
    bookedDuration: "预订时长",
    actualEndTime: "实际结束时间（30分钟为单位）",
    submit: "提交",
    editExtraOrder: "修改",
    submitConfirm: "确认提交",
    submitting: "提交中...",
    selectEndTime: "请选择结束时间",
    enterChat: "进入聊天室",
    unreadEnterChat: "有新消息，进入聊天室",
    tripCommunicationCenter: "订单沟通中心",
    driverSections: "司机功能",
    route: "路线",
    changePassword: "修改密码",
    faceIdLogin: "通过 Face ID 登录",
    faceIdLoginHint: "使用已保存的账号和密码，下次可以更快登录",
    faceIdChecking: "正在确认 Face ID...",
    faceIdEnabled: "已开启 Face ID 登录",
    faceIdDisabled: "已关闭 Face ID 登录",
    faceIdUnavailable: "当前设备不可用 Face ID",
    faceIdCredentialRequired: "请先退出登录，在登录页勾选记住账号后，再开启 Face ID",
    faceIdAuthFailed: "Face ID 没有启动，请确认手机已开启 Face ID 后再试",
    loginWithFaceId: "通过 Face ID 登录",
    faceIdReason: "请使用 Face ID 登录 Big Taxi Driver",
    emergencyContact: "紧急支持",
    emergencyContactHint: "服务中遇到紧急问题或异常时使用",
    contactDispatch: "联系配车担当",
    onlineBigTaxiSupport: "在线联系调度中心",
    phoneBigTaxiSupport: "电话联系调度中心",
    customerServicePhoneNumber: "客服电话",
    callBigTaxiSupportPrompt: "拨打调度中心电话",
    callNow: "拨打",
    close: "关闭",
    reportAccidentTrouble: "事故 / 问题报告",
    openOrderDetailToReport: "从订单详情报告",
    legalComplianceCenter: "法务与合规中心",
    legalComplianceCenterHint: "查看使用规则、隐私、定位、通知等重要事项",
    termsOfUse: "使用条款",
    privacyPolicy: "隐私政策",
    viewFullPrivacyPolicy: "打开完整隐私政策",
    privacyPolicyBody: "Big Taxi Driver 仅在司机账号管理、派单、身份确认、结算、紧急处理、服务质量管理和合规所需范围内使用个人信息。\n\n可能使用的信息包括姓名、联系方式、身份证明文件、车辆资料、银行账户、登录设备信息和 App 使用记录。\n\n在业务、安全或法律合规必要时，相关信息可能会以最小必要范围提供给调度、管理员、支付服务、身份确认服务或系统服务商。",
    locationInformation: "位置信息说明",
    locationInformationBody: "位置信息用于记录订单状态、确认到达和服务进度、支持紧急处理，以及在发生问题时保留运营记录。\n\n司机更新状态时，时间和位置可能会保存到订单履历，并在后台管理端显示。目的在于派单准确性和安全确认，不是无关的持续监控。\n\n如果关闭定位权限，部分状态更新、证据记录和紧急支援功能可能无法正常使用。",
    notificationInformation: "通知说明",
    notificationInformationBody: "通知用于接收新订单、订单变更、取消、调度消息、乘客消息和紧急联系。\n\n锁屏通知会保持简短，不会在正文显示完整手机号、酒店房号、详细个人隐私等敏感信息。\n\n如果关闭通知，可能会错过重要的时间变更或紧急联系。",
    safeDrivingGuide: "安全驾驶指南",
    safeDrivingGuideBody: "服务中必须遵守交通法规，并以安全为第一优先。禁止超速、危险驾驶、开车时操作手机、身体不适时继续驾驶。\n\n车辆需要保持清洁，并按照公司要求准备饮用水、举牌、车辆状态和司机着装等项目。\n\n发生事故、延误、乘客纠纷、遗失物品、车辆故障时，请及时联系调度，不要自行承诺退款、补偿或责任判断。",
    emergencyResponse: "紧急应对",
    emergencyResponseBody: "发生人身事故、物损事故、急病、车辆故障、重大乘客纠纷时，请先确保人员安全，必要时联系警察、消防或急救。\n\n随后通过 App 紧急联系或电话向调度报告地点、订单号、现场情况和乘客安全状态。\n\n现场不要自行承诺退款、赔偿或责任划分，必须等待管理员确认。",
    accountSuspensionScoreRules: "账号暂停与评分规则",
    accountSuspensionScoreRulesBody: "司机评分会根据完成率、取消、迟到、投诉、车辆和着装标准、沟通情况、异常报告等自动或由管理员更新。\n\n如出现严重违规、虚假报告、无故取消、危险驾驶、不当处理个人信息、投诉累积、证件过期等情况，接单功能可能会被暂停。\n\n评分低于要求或必要证件过期时，司机可以查看已有订单，但不能继续接新订单。",
    deviceManagement: "登录设备管理",
    loginDeviceManagement: "登录设备管理",
    loginDeviceManagementHint: "查看和删除这个账号登录过的设备",
    loginDevicesEmpty: "没有找到登录设备",
    currentDevice: "当前设备",
    lastLoginAt: "最后登录",
    removeDevice: "删除",
    removingDevice: "删除中...",
    loginDeviceRemoved: "登录设备已删除",
    loginDeviceLoadFailed: "无法读取登录设备",
    loginDeviceRemoveFailed: "无法删除这个设备",
    aboutApp: "应用信息",
    versionNumber: "司机端应用",
    notificationSettings: "通知设置",
    languageSettings: "语言设置",
    languageSettingsHint: "可以改变软件的显示语言",
    languageSaved: "语言已切换",
    driverNoticeTitle: "通知",
    driverNoticeHistory: "通知",
    driverNoticeEmpty: "暂无通知",
    importantNotificationTitle: "重要通知",
    importantNotificationAck: "确认已读",
    importantNotificationOpenOrder: "查看订单",
    importantNotificationCreatedAt: "通知时间",
    importantNotificationPending: "待确认",
    importantNotificationSaving: "正在确认…",
    importantNotificationFailed: "未收到确认结果，请重试或稍后查看，记录可能已保存。",
    importantNotificationLater: "稍后处理（保留未读）",
    orderChangeUpdated: "有更新",
    orderChangeTime: "时间",
    orderChangePickup: "上车点",
    orderChangeDropoff: "下车点",
    orderChangeNote: "备注",
    orderChangeCancelled: "取消",
    newReservationNotification: "新订单通知",
    reservationChangeNotification: "订单变更通知",
    urgentContactNotification: "紧急联系通知",
    notificationSettingsSaved: "通知设置已保存",
    logout: "退出登录",
    driverAppVersion: "2.0",
    firstLoginChangePassword: "首次登录请修改密码",
    currentPassword: "当前密码",
    newPassword: "新密码",
    confirmNewPassword: "确认新密码",
    currentPasswordPlaceholder: "请输入当前密码",
    newPasswordPlaceholder: "至少6个字符",
    confirmPasswordPlaceholder: "再次输入新密码",
    passwordTooShort: "新密码至少需要6个字符",
    passwordMismatch: "两次输入的密码不一致",
    passwordChanged: "密码修改成功",
    systemConfigError: "系统配置错误，请联系管理员",
    passwordChangeFailed: "密码修改失败",
    timeOffRequest: "休假请求",
    timeOffHint: "提交后马上生效，管理员配车时会看到提示",
    startDate: "开始日期",
    endDate: "结束日期",
    allDayRange: "全天休假 / 日期区间",
    endTime: "结束时间",
    reason: "备注",
    reasonPlaceholder: "例：私用、医院、家庭安排等",
    submitTimeOff: "提交休假",
    myTimeOffRecords: "我的休假记录",
    noTimeOffRecords: "暂无休假记录",
    cancelled: "已取消",
    active: "正常",
    timeOffRegistered: "休假已登记",
    getTimeOffFailed: "获取休假记录失败",
    submitFailed: "提交失败",
    cancelFailed: "取消失败",
    chooseStartDate: "请选择开始日期",
    chooseStartEndTime: "请选择开始和结束时间",
    confirmCancelTimeOff: "确定取消这条休假记录吗？",
    fullDay: "全天",
    loginExpired: "登录已过期，请重新登录",
    accountDisabled: "账号已被禁用，请联系管理员",
    orderFetchFailed: "获取订单失败",
    unknownError: "未知错误",
    unknownStatus: "状态未知",
    networkError: "网络异常，请检查网络连接",
    reportSuccess: "汇报成功",
    reportFailed: "汇报失败",
    cancelExtraConfirm: "确定要取消这个追加排班吗？",
    extraServiceTypes: {
      airport_sign: "机场举牌",
      infant_seat: "婴儿座椅",
      airport_pickup_sign: "机场举牌",
      hotel_sign: "酒店举牌",
      english_driver: "英语司机",
      tokyo_station_platform: "东京站站台送达",
      platform_dropoff: "站台送达",
      tokyo_station_sign: "东京站举牌",
      odawara_station_sign: "小田原站举牌",
      shinkansen_ticket: "新干线票务协助",
      hiace_14_seat_upgrade: "升级到14座海狮",
      fuji_5th_station: "富士山五合目追加费",
      child_seat: "儿童座椅",
      extended_waiting_time: "延长等待时间",
      other: "其他服务",
    },
    openMap: "确认地图",
    mapConfirm: "地图确认",
    pickup: "上车地点",
    dropoff: "下车地点",
    appleMaps: "苹果地图",
    googleMaps: "Google Maps",
    startNavigation: "打开导航",
    cancel: "取消",
    retryPending: "正在重试未提交状态",
    statusUpdated: "状态已更新",
    statusQueued: "网络不稳定，状态已保存，联网后会自动同步",
    statusSyncing: "正在同步未提交状态",
    statusSynced: "未提交状态已同步",
    statusPendingCount: "待同步状态",
    issueReport: "报告异常",
    cancelIssueReport: "取消异常报告",
    issueReportCancelled: "异常报告已取消",
    returnOrder: "退回订单",
    returnOrderTitle: "退回原因",
    returnOrderPlaceholder: "可填写退回原因",
    returnOrderSwipe: "退回订单池",
    returnOrderConfirm: "确定要退回这个订单吗？",
    returnOrderSuccess: "订单已退回",
    returnOrderFailed: "退回订单失败",
    swipeToConfirm: "向右滑动",
    pleaseWait: "请稍候",
    status: {
      pending: "待确认",
      pending_confirmation: "待确认",
      confirmed: "已确认",
      completed: "已完成",
      cancelled: "已取消",
    },
    driverStatus: {
      assigned: "待司机确认",
      confirmed: "司机已确认",
      driver_departed: "司机已出发",
      arrived_pickup: "已到达上车地点",
      passenger_onboard: "客人已上车",
      in_service: "服务中",
      completed: "服务完成",
      issue_reported: "已报告异常",
    },
    driverActions: {
      confirmed: "确认订单",
      driver_departed: "司机出发",
      arrived_pickup: "已到达上车地点",
      passenger_onboard: "客人已上车",
      in_service: "开始服务",
      completed: "服务完成",
    },
    serviceType: {
      transfer: "接送",
      charter: "包车",
    },
    issueOptions: {
      unable_contact_passenger: "联系不上乘客",
      passenger_no_show: "乘客未出现",
      passenger_late: "乘客迟到",
      flight_or_train_delay: "航班/列车延误",
      pickup_location_problem: "上车地点不明确",
      route_or_destination_changed: "临时变更路线/目的地",
      extra_waiting_time: "需要额外等待",
      luggage_or_item_left: "乘客有遗忘物品",
      vehicle_or_traffic_issue: "车辆/交通异常",
      order_information_problem: "订单信息有误",
      other: "其他问题",
    },
  },
  zh_tw: {
    loading: "加載中...",
    cachedData: "當前為緩存數據",
    offlineOrderPackReady: (count) => `未來48小時已離線保存 ${count} 個訂單`,
    offlineSignboardReady: (count) => `舉牌PDF ${count} 份`,
    offlineSignboardUnavailable: "此訂單的舉牌 PDF 尚未緩存，請聯網後在我的訂單刷新一次。",
    nextOrder: "下一單",
    myOrders: "我的訂單",
    conversations: "對話",
    conversationListHint: "聊天室開啟後顯示在進行中，訂單開始24小時後移入已完成",
    activeConversations: "進行中",
    completedConversations: "已完成",
    noActiveConversations: "暫無進行中的訂單對話",
    noCompletedConversations: "暫無已完成的訂單對話",
    noConversations: "暫無可用的訂單對話",
    myPage: "我的主頁",
    myPageTab: "我",
    profilePhotoMenuTitle: "更換頭像",
    chooseFromAlbum: "從相冊選擇",
    takeProfilePhoto: "拍照",
    orderPool: "訂單池",
    poolOrders: "訂單池",
    applyOrder: "申請接單",
    applyingOrder: "提交中...",
    cancelApplication: "撤銷申請",
    applicationPending: "已申請",
    applySuccess: "接單成功",
    poolDisabled: "當前不能接新訂單",
    orderPoolOnboardingRequired: "完成上崗資料審查即可接單",
    orderPoolExpiredDocumentRequired: (name) => `${name}資料已過期，請更新後再接單`,
    orderPoolTemporarilyUnavailable: "當前暫時不能接單",
    documentExpiryNames: { driver_license: "駕照", residence_card: "在留卡", passport: "護照", vehicle_inspection: "車檢證", optional_insurance: "任意保險" },
    noPoolOrders: "暫無可接訂單\n有新訂單時會第一時間通知你\n請保持 App 通知開啓",
    poolDecisionHint: "訂單發佈後30分鐘內，系統將優先分配給積分較高的司機",
    dispatchPriceLabel: "派單價",
    driverScore: "當前積分",
    driverScoreHint: "根據完成率、取消和投訴情況自動更新",
    monthlyRevenueTitle: "本月売上 / 報酬",
    monthlyCompletedOrders: "本月完成件數",
    monthlyReward: "本月報酬",
    monthlyUnsettled: "未精算",
    myWallet: "我的錢包",
    settlement: "結算",
    viewDetails: "查看明細",
    walletDetailsTitle: "結算明細",
    walletOrderAmount: "訂單金額",
    walletOvertimeFee: "超時費",
    walletSettlementDate: "結算日期",
    walletPaymentStatus: "打款狀態",
    walletPaid: "已打款",
    walletUnpaid: "未打款",
    walletNoDetails: "暫無結算明細",
    scoreDetailsTitle: "積分明細",
    scoreNoDetails: "暫無積分明細",
    scoreOldNew: "積分變化",
    scoreAdjustment: "積分調整",
    scoreEventTypes: {
      order_completed_bonus: "完成訂單獎勵",
      driver_complaint_penalty: "投訴扣分",
      completed_bonus_reversed_by_complaint: "投訴成立撤回完成獎勵",
      driver_complaint_reversed: "投訴撤銷返還扣分",
      completed_bonus_restored_after_complaint_reverse: "投訴撤銷恢復完成獎勵",
      order_return_penalty: "退回訂單扣分",
    },
    currentMonthSettlementAmount: "當月結算金額",
    nextMonthSettlementAmount: "次月結算金額",
    driverSettlementRule: "1日至月末的訂單，在次月15日結算",
    canAcceptOrders: "可以接新訂單",
    cannotAcceptOrders: "禁止接新訂單",
    onboardingTitle: "上崗資料審核",
    businessStartCheck: "所有項目全部完成後可以開始接單",
    businessStartCheckHint: "請依次完成個人信息、車輛信息、培訓和整備場檢查",
    documentManagement: "資料 / 證件管理",
    documentManagementTitle: "司機資料 / 證件管理",
    documentManagementHint: "駕照、車檢證、保險、在留卡/日本國籍、銀行賬戶",
    personalDocumentsTitle: "個人資料 / 證件",
    personalDocumentsHint: "駕照、在留卡、聯繫方式",
    vehicleDocumentsTitle: "車輛資料",
    vehicleDocumentsHint: "車檢證、保險、車輛照片",
    payoutAccountTitle: "收款賬戶",
    payoutAccountHint: "銀行賬戶、結算信息",
    documentExpired: "有資料已經過期",
    documentExpiredCount: "項過期",
    documentExpiredAutoPause: "資料過期後，新訂單接單功能會自動暫停。",
    documentExpiringSoon: (count) => `${count}項資料將在30天內到期，請盡早更新。`,
    documentSaved: "資料已保存",
    needsCompletion: "待完善",
    driverLicenseInfo: "駕照信息",
    vehicleInspectionDocument: "車檢證",
    vehicleInspectionExpiry: "車檢證到期日",
    optionalInsurance: "任意保險",
    optionalInsuranceCompany: "保險公司名稱",
    optionalInsurancePolicyNumber: "保險證券號",
    optionalInsuranceExpiry: "任意保險到期日",
    optionalInsuranceFront: "任意保險正面",
    optionalInsuranceBack: "任意保險反面",
    residenceOrPassport: "在留卡 / 日本國籍",
    residenceCardNumber: "在留卡編號",
    japaneseNational: "日本國籍",
    validUntil: "有效期限至",
    longTermValid: "長期有效",
    bankAccount: "銀行賬戶",
    bankName: "銀行名",
    bankBranch: "支店名",
    bankAccountType: "賬戶類型",
    bankAccountTypeOptions: [{ value: "", label: "請選擇" }, { value: "普通", label: "普通" }, { value: "當座", label: "當座" }],
    bankAccountNumber: "賬戶號碼",
    bankAccountHolder: "賬戶名義",
    saveDocuments: "保存資料",
    onboardingSubmitted: "已提交，等待後台審核",
    trainingPassed: "培訓測試已通過",
    personalInfo: "個人信息",
    fullName: "姓名",
    dateOfBirth: "出生日期",
    address: "住址",
    driverServiceLanguages: "司機可服務語言",
    driverServiceLanguageNames: {
      ja: "日語",
      en: "英語",
      es: "西班牙語",
      ko: "韓語",
      zh: "中文",
    },
    chooseFromAlbum: "從相冊選擇",
    takeProfilePhoto: "拍照",
    openAlbumOrChooseFile: "打開相冊/選擇文件",
    noFileSelected: "未選擇文件",
    fileSelected: "已選擇",
    onboardingMissingFields: "請補充以下必填資料",
    onboardingFileTooLarge: "文件仍然過大，請重新拍照或選擇較小的文件。",
    onboardingFileReadFailed: "無法讀取文件，請重新選擇。",
    residenceCardNumber: "在留卡編號",
    residenceCardExpiry: "在留卡期限",
    driverLicenseNumber: "駕照編號",
    driverLicenseExpiry: "駕照到期日期",
    residenceCardFront: "在留卡正面",
    residenceCardBack: "在留卡反面",
    driverLicenseFront: "駕照正面",
    driverLicenseBack: "駕照反面",
    plateRegion: "管轄地名",
    plateClass: "分類番號",
    plateKana: "平假名",
    plateDigits: "一連指定番號",
    vehicleModel: "車輛型號",
    vehicleModelOptions: [{ value: "alphard", label: "阿爾法" }, { value: "hiace", label: "海獅" }],
    vehicleColor: "車輛顏色",
    vehicleColorOptions: [{ value: "black", label: "黑色" }],
    vehicleYear: "年式（2016年之後）",
    inspectionCertificate: "車檢證",
    recordCertificate: "記錄事項書",
    optionalInsurancePhoto: "任意保險照片",
    compulsoryInsuranceExpiry: "自賠責有效期",
    compulsoryInsurancePhoto: "自賠責照片",
    training: "上崗前培訓",
    submitTraining: "提交測試",
    trainingLessonProgress: "學習",
    trainingMaterial: "學習資料",
    trainingUnderstandPage: "我已理解本頁內容",
    trainingConfirmed: "已確認",
    trainingNext: "下一頁",
    trainingPrev: "上一頁",
    trainingStartTest: "進入測試",
    trainingLocked: "確認全部學習資料後，才能進入培訓測試。",
    trainingWrongHint: "有題目未答對。請回到對應學習資料復習後再提交。",
    trainingCritical: "重點提醒",
    vehicleInspection: "整備場檢查 / 貼標",
    inspectionLocation: "整備場名稱",
    inspectionCompleted: "已完成車輛檢查",
    labelAttached: "已完成貼標",
    inspectionSite: "指定整備場",
    inspectionAddressPending: "整備場地址由管理員通知",
    inspectionFutureSelectable: "整備場可根據後台配置選擇。",
    appointmentDate: "預約日期",
    appointmentTime: "預約時間（30分鐘單位）",
    inspectionNoticeTitle: "確認事項",
    inspectionFeeWarning: "JPY 5,000 用於線下現場車輛檢查和實體 Big Taxi 公司貼標，不用於購買數位功能或 App 使用資格。如果車輛或著裝未通過現場檢查標準，該線下服務費用不退。",
    confirmInspectionAppointment: "確認預約內容",
    inspectionPaymentStep: "車輛檢查費用",
    payInspectionFee: "支付線下車輛檢查和實體貼標費用",
    inspectionQrTitle: "整備場核銷碼",
    inspectionQrHint: "付款後請保存二維碼和8位數核銷碼，到整備場出示。",
    inspectionPaymentStatus: "付款狀態",
    paymentSetupRequired: "Square 付款配置未完成",
    paymentLinkFailed: "付款頁面準備失敗，請重試。",
    inspectionPaymentStatusLabels: { pending: "未付款", created: "等待付款", payment_setup_required: "等待設定付款", payment_link_failed: "付款準備失敗", paid: "已付款", completed: "已付款", canceled: "已取消", cancelled: "已取消", failed: "付款失敗" },
    squareTrust: "銀行卡信息由 Square 安全處理，本系統不會保存卡號。",
    pending: "未完成",
    onboardingStatus: { pending: "未完成", submitted: "待審核", approved: "已完成", rejected: "已退回" },
    auditStatus: "審核狀態",
    rejectionReason: "駁回原因",
    onboardingAuditStates: { pending_submission: "待提交", reviewing: "審核中", needs_changes: "需修改", approved: "已通過" },
    onboardingItemStatus: { to_complete: "待完善", reviewing: "審核中", needs_changes: "需修改", completed: "已通過", incomplete: "未完成", not_started: "未開始" },
    onboardingSteps: { personal_info: "個人信息", vehicle_info: "車輛信息", training: "上崗前培訓", vehicle_inspection: "整備場檢查/貼標", final_review: "最終審核" },
    settings: "設置",
    fleetJoinTitle: "加入車隊",
    fleetJoinHint: "如需加入已開通車隊，請輸入負責人提供的永久車隊碼。",
    fleetCodePlaceholder: "請輸入車隊碼",
    fleetJoin: "加入",
    fleetJoining: "加入中…",
    fleetJoinSuccess: "已加入車隊",
    fleetJoinFailed: "加入車隊失敗，請確認車隊碼後重試。",
    fleetMembershipLabel: "所屬車隊",
    fleetMembershipTitle: "所屬車隊",
    fleetMembershipUnknown: "正在確認車隊信息",
    fleetMembershipHint: "這是你當前所屬的車隊。",
    fleetExitRequest: "申請退出車隊",
    fleetExitRequestHint: "填寫理由並遞交後，由車隊主賬號審核。審核通過後可加入其他車隊。",
    fleetExitReasonPlaceholder: "請填寫申請退出的原因",
    fleetExitSubmitting: "遞交中…",
    fleetExitRequestPending: "退出申請已遞交，等待車隊主賬號審核",
    fleetExitRequestSuccess: "退出申請已遞交，等待車隊主賬號審核。",
    fleetExitRequestFailed: "退出申請遞交失敗，請稍後重試。",
    fleetManagementTitle: "車隊管理",
    fleetManagementHint: "管理配車、司機賬號和車隊設置。",
    fleetMasterAccount: "車隊主賬號",
    fleetDrivers: "司機",
    fleetVehicles: "車輛",
    fleetDispatchableOrders: "可派訂單",
    timeOff: "請假申請",
    upcoming: "即將出發",
    completed: "已完成",
    goComplete: "去完成",
    all: "全部",
    add: "追加",
    refresh: "刷新",
    official: "正式",
    unreadMessage: "新消息",
    noOrders: "暫無訂單",
    unknownCustomer: "未知客戶",
    downloadPdf: "下載 PDF",
    downloading: "下載中...",
    addToCalendar: "添加到日曆",
    addedToCalendar: "已添加到日曆",
    calendarDateMissing: "訂單日期缺失，無法添加到日曆",
    calendarPermissionDenied: "請在 iPhone 設置里允許日曆權限",
    calendarNativeUnavailable: "日曆功能未準備好，請重新打開 App",
    reportedAt: "已彙報",
    reportDuration: "彙報時長",
    dispatchPrice: "派單價格",
    fleetAssignedDriver: "實際司機",
    fleetUnassigned: "待指派",
    fleetAssignDriver: "指派司機",
    fleetReassignDriver: "改派司機",
    fleetChooseDriver: "選擇司機",
    fleetChooseVehicle: "選擇車輛",
    fleetSelectedDriver: "已選擇司機",
    fleetAssignedVehicle: "實際車輛",
    fleetAssignVehicle: "指定此車輛",
    fleetNoSavedVehicles: "暫無已保存車輛，請點擊上方按鈕直接添加",
    fleetAddVehicle: "直接添加車輛",
    fleetVehicleType: "車型",
    fleetPlateNumber: "車牌號",
    fleetPlatePlaceholder: "例如：東京 500 1234",
    fleetVehicleSaveHint: "保存後會立即指定給本訂單，以後可直接從列表選擇。",
    fleetSaveAndAssign: "保存並指定",
    fleetDeleteVehicle: "刪除",
    fleetVehicleDeleted: "車輛已從保存列表刪除",
    change: "更換",
    vehicle: "車輛",
    fleetAssigning: "指派中...",
    fleetAssignmentLocked: "服務開始後不能改派",
    fleetNoAvailableDrivers: "暫無可指派的車隊司機",
    fleetOrderReadOnly: "這是車隊所屬訂單，僅實際被指派的司機可以更新服務狀態。",
    orderDetail: "訂單詳情",
    back: "返回",
    orderStatus: "訂單狀態",
    booking: "預約",
    service: "服務",
    driver: "司機",
    statusActions: "訂單狀態操作",
    chooseIssue: "選擇異常項目",
    issuePlaceholder: "手動輸入問題說明",
    submitIssue: "提交異常",
    dateTime: "日期時間",
    charterDuration: "包車時長",
    hours: "小時",
    dispatchContact: "調度聯繫",
    dispatchNote: "調度備注",
    tripInfo: "行程信息",
    terminal: "航站樓",
    flightNumber: "航班/船班號",
    passengerInfo: "乘客信息",
    passengerName: "乘客姓名",
    customerCode: "客戶代碼",
    phone: "聯繫電話",
    passengerCount: "乘客人數",
    luggageCount: "行李數量",
    childSeats: "兒童座椅",
    peopleUnit: "人",
    luggageUnit: "件",
    vehicleInfo: "車輛信息",
    vehicleType: "車型",
    plateNumber: "車牌號",
    brand: "品牌",
    extraServices: "額外服務",
    notes: "備注",
    reportCharterTime: "彙報包車時間",
    reportedEndTime: "已彙報結束時間",
    modifyEndTime: "修改結束時間",
    reportEndTime: "彙報包車結束時間",
    orderNo: "訂單號",
    startTime: "開始時間",
    bookedDuration: "預訂時長",
    actualEndTime: "實際結束時間（30分鐘為單位）",
    submit: "提交",
    editExtraOrder: "修改",
    submitConfirm: "確認提交",
    submitting: "提交中...",
    selectEndTime: "請選擇結束時間",
    enterChat: "進入聊天室",
    unreadEnterChat: "有新消息，進入聊天室",
    tripCommunicationCenter: "訂單溝通中心",
    driverSections: "司機功能",
    route: "路線",
    changePassword: "修改密碼",
    faceIdLogin: "通過 Face ID 登錄",
    faceIdLoginHint: "使用已保存的賬號和密碼，下次可以更快登錄",
    faceIdChecking: "正在確認 Face ID...",
    faceIdEnabled: "已開啓 Face ID 登錄",
    faceIdDisabled: "已關閉 Face ID 登錄",
    faceIdUnavailable: "當前設備不可用 Face ID",
    faceIdCredentialRequired: "請先退出登錄，在登錄頁勾選記住賬號後，再開啓 Face ID",
    faceIdAuthFailed: "Face ID 沒有啓動，請確認手機已開啓 Face ID 後再試",
    loginWithFaceId: "通過 Face ID 登錄",
    faceIdReason: "請使用 Face ID 登錄 Big Taxi Driver",
    emergencyContact: "緊急支持",
    emergencyContactHint: "服務中遇到緊急問題或異常時使用",
    contactDispatch: "聯繫配車擔當",
    onlineBigTaxiSupport: "在線聯繫調度中心",
    phoneBigTaxiSupport: "電話聯繫調度中心",
    customerServicePhoneNumber: "客服電話",
    callBigTaxiSupportPrompt: "撥打調度中心電話",
    callNow: "撥打",
    close: "關閉",
    reportAccidentTrouble: "事故 / 問題報告",
    openOrderDetailToReport: "從訂單詳情報告",
    legalComplianceCenter: "法務與合規中心",
    legalComplianceCenterHint: "查看使用規則、隱私、定位、通知等重要事項",
    termsOfUse: "使用條款",
    privacyPolicy: "隱私政策",
    viewFullPrivacyPolicy: "開啟完整隱私政策",
    privacyPolicyBody: "Big Taxi Driver 僅在司機賬號管理、派單、身份確認、結算、緊急處理、服務質量管理和合規所需範圍內使用個人信息。\n\n可能使用的信息包括姓名、聯繫方式、身份證明文件、車輛資料、銀行賬戶、登錄設備信息和 App 使用記錄。\n\n在業務、安全或法律合規必要時，相關信息可能會以最小必要範圍提供給調度、管理員、支付服務、身份確認服務或系統服務商。",
    locationInformation: "位置信息說明",
    locationInformationBody: "位置信息用於記錄訂單狀態、確認到達和服務進度、支持緊急處理，以及在發生問題時保留運營記錄。\n\n司機更新狀態時，時間和位置可能會保存到訂單履歷，並在後台管理端顯示。目的在於派單準確性和安全確認，不是無關的持續監控。\n\n如果關閉定位權限，部分狀態更新、證據記錄和緊急支援功能可能無法正常使用。",
    notificationInformation: "通知說明",
    notificationInformationBody: "通知用於接收新訂單、訂單變更、取消、調度消息、乘客消息和緊急聯繫。\n\n鎖屏通知會保持簡短，不會在正文顯示完整手機號、酒店房號、詳細個人隱私等敏感信息。\n\n如果關閉通知，可能會錯過重要的時間變更或緊急聯繫。",
    safeDrivingGuide: "安全駕駛指南",
    safeDrivingGuideBody: "服務中必須遵守交通法規，並以安全為第一優先。禁止超速、危險駕駛、開車時操作手機、身體不適時繼續駕駛。\n\n車輛需要保持清潔，並按照公司要求準備飲用水、舉牌、車輛狀態和司機著裝等項目。\n\n發生事故、延誤、乘客糾紛、遺失物品、車輛故障時，請及時聯繫調度，不要自行承諾退款、補償或責任判斷。",
    emergencyResponse: "緊急應對",
    emergencyResponseBody: "發生人身事故、物損事故、急病、車輛故障、重大乘客糾紛時，請先確保人員安全，必要時聯繫警察、消防或急救。\n\n隨後通過 App 緊急聯繫或電話向調度報告地點、訂單號、現場情況和乘客安全狀態。\n\n現場不要自行承諾退款、賠償或責任劃分，必須等待管理員確認。",
    accountSuspensionScoreRules: "賬號暫停與評分規則",
    accountSuspensionScoreRulesBody: "司機評分會根據完成率、取消、遲到、投訴、車輛和著裝標準、溝通情況、異常報告等自動或由管理員更新。\n\n如出現嚴重違規、虛假報告、無故取消、危險駕駛、不當處理個人信息、投訴累積、證件過期等情況，接單功能可能會被暫停。\n\n評分低於要求或必要證件過期時，司機可以查看已有訂單，但不能繼續接新訂單。",
    deviceManagement: "登錄設備管理",
    loginDeviceManagement: "登錄設備管理",
    loginDeviceManagementHint: "查看和刪除這個賬號登錄過的設備",
    loginDevicesEmpty: "沒有找到登錄設備",
    currentDevice: "當前設備",
    lastLoginAt: "最後登錄",
    removeDevice: "刪除",
    removingDevice: "刪除中...",
    loginDeviceRemoved: "登錄設備已刪除",
    loginDeviceLoadFailed: "無法讀取登錄設備",
    loginDeviceRemoveFailed: "無法刪除這個設備",
    aboutApp: "應用資訊",
    versionNumber: "司機端應用",
    notificationSettings: "通知設置",
    languageSettings: "語言設置",
    languageSettingsHint: "可以改變軟件的顯示語言",
    languageSaved: "語言已切換",
    driverNoticeTitle: "通知",
    driverNoticeHistory: "通知",
    driverNoticeEmpty: "暫無通知",
    importantNotificationTitle: "重要通知",
    importantNotificationAck: "確認已讀",
    importantNotificationOpenOrder: "查看訂單",
    importantNotificationCreatedAt: "通知時間",
    importantNotificationPending: "待確認",
    importantNotificationSaving: "正在確認…",
    importantNotificationFailed: "未收到確認結果，請重試或稍後查看，記錄可能已儲存。",
    importantNotificationLater: "稍後處理（保留未讀）",
    orderChangeUpdated: "有更新",
    orderChangeTime: "時間",
    orderChangePickup: "上車點",
    orderChangeDropoff: "下車點",
    orderChangeNote: "備注",
    orderChangeCancelled: "取消",
    newReservationNotification: "新訂單通知",
    reservationChangeNotification: "訂單變更通知",
    urgentContactNotification: "緊急聯繫通知",
    notificationSettingsSaved: "通知設置已保存",
    logout: "退出登錄",
    driverAppVersion: "2.0",
    firstLoginChangePassword: "首次登錄請修改密碼",
    currentPassword: "當前密碼",
    newPassword: "新密碼",
    confirmNewPassword: "確認新密碼",
    currentPasswordPlaceholder: "請輸入當前密碼",
    newPasswordPlaceholder: "至少6個字符",
    confirmPasswordPlaceholder: "再次輸入新密碼",
    passwordTooShort: "新密碼至少需要6個字符",
    passwordMismatch: "兩次輸入的密碼不一致",
    passwordChanged: "密碼修改成功",
    systemConfigError: "系統配置錯誤，請聯繫管理員",
    passwordChangeFailed: "密碼修改失敗",
    timeOffRequest: "休假請求",
    timeOffHint: "提交後馬上生效，管理員配車時會看到提示",
    startDate: "開始日期",
    endDate: "結束日期",
    allDayRange: "全天休假 / 日期區間",
    endTime: "結束時間",
    reason: "備注",
    reasonPlaceholder: "例：私用、醫院、家庭安排等",
    submitTimeOff: "提交休假",
    myTimeOffRecords: "我的休假記錄",
    noTimeOffRecords: "暫無休假記錄",
    cancelled: "已取消",
    active: "正常",
    timeOffRegistered: "休假已登記",
    getTimeOffFailed: "獲取休假記錄失敗",
    submitFailed: "提交失敗",
    cancelFailed: "取消失敗",
    chooseStartDate: "請選擇開始日期",
    chooseStartEndTime: "請選擇開始和結束時間",
    confirmCancelTimeOff: "確定取消這條休假記錄嗎？",
    fullDay: "全天",
    loginExpired: "登錄已過期，請重新登錄",
    accountDisabled: "賬號已被禁用，請聯繫管理員",
    orderFetchFailed: "獲取訂單失敗",
    unknownError: "未知錯誤",
    unknownStatus: "狀態未知",
    networkError: "網絡異常，請檢查網絡連接",
    reportSuccess: "彙報成功",
    reportFailed: "彙報失敗",
    cancelExtraConfirm: "確定要取消這個追加排班嗎？",
    extraServiceTypes: {
      airport_sign: "機場舉牌",
      infant_seat: "嬰兒座椅",
      airport_pickup_sign: "機場舉牌",
      hotel_sign: "酒店舉牌",
      english_driver: "英語司機",
      tokyo_station_platform: "東京站站台送達",
      platform_dropoff: "站台送達",
      tokyo_station_sign: "東京站舉牌",
      odawara_station_sign: "小田原站舉牌",
      shinkansen_ticket: "新幹線票務協助",
      hiace_14_seat_upgrade: "升級到14座海獅",
      fuji_5th_station: "富士山五合目追加費",
      child_seat: "兒童座椅",
      extended_waiting_time: "延長等待時間",
      other: "其他服務",
    },
    openMap: "確認地圖",
    mapConfirm: "地圖確認",
    pickup: "上車地點",
    dropoff: "下車地點",
    appleMaps: "蘋果地圖",
    googleMaps: "Google Maps",
    startNavigation: "打開導航",
    cancel: "取消",
    retryPending: "正在重試未提交狀態",
    statusUpdated: "狀態已更新",
    statusQueued: "網絡不穩定，狀態已保存，聯網後會自動同步",
    statusSyncing: "正在同步未提交狀態",
    statusSynced: "未提交狀態已同步",
    statusPendingCount: "待同步狀態",
    issueReport: "報告異常",
    cancelIssueReport: "取消異常報告",
    issueReportCancelled: "異常報告已取消",
    returnOrder: "退回訂單",
    returnOrderTitle: "退回原因",
    returnOrderPlaceholder: "可填寫退回原因",
    returnOrderSwipe: "退回訂單池",
    returnOrderConfirm: "確定要退回這個訂單嗎？",
    returnOrderSuccess: "訂單已退回",
    returnOrderFailed: "退回訂單失敗",
    swipeToConfirm: "向右滑動",
    pleaseWait: "請稍候",
    status: {
      pending: "待確認",
      pending_confirmation: "待確認",
      confirmed: "已確認",
      completed: "已完成",
      cancelled: "已取消",
    },
    driverStatus: {
      assigned: "待司機確認",
      confirmed: "司機已確認",
      driver_departed: "司機已出發",
      arrived_pickup: "已到達上車地點",
      passenger_onboard: "客人已上車",
      in_service: "服務中",
      completed: "服務完成",
      issue_reported: "已報告異常",
    },
    driverActions: {
      confirmed: "確認訂單",
      driver_departed: "司機出發",
      arrived_pickup: "已到達上車地點",
      passenger_onboard: "客人已上車",
      in_service: "開始服務",
      completed: "服務完成",
    },
    serviceType: {
      transfer: "接送",
      charter: "包車",
    },
    issueOptions: {
      unable_contact_passenger: "聯繫不上乘客",
      passenger_no_show: "乘客未出現",
      passenger_late: "乘客遲到",
      flight_or_train_delay: "航班/列車延誤",
      pickup_location_problem: "上車地點不明確",
      route_or_destination_changed: "臨時變更路線/目的地",
      extra_waiting_time: "需要額外等待",
      luggage_or_item_left: "乘客有遺忘物品",
      vehicle_or_traffic_issue: "車輛/交通異常",
      order_information_problem: "訂單信息有誤",
      other: "其他問題",
    },
  },
};

export function normalizeDriverLanguage(language, fallback = "zh_cn") {
  if (language === "zh") return "zh_cn";
  return driverText[language] ? language : fallback;
}

export function getDriverNoticeLanguage(language = getDriverLanguage()) {
  const normalizedLanguage = normalizeDriverLanguage(language);
  if (normalizedLanguage === "zh_tw") return "zh_tw";
  if (normalizedLanguage === "ja" || normalizedLanguage === "en") return normalizedLanguage;
  return "zh_cn";
}

export function getLocalizedDriverNotice(notice, language = getDriverLanguage()) {
  const translations = notice?.translations && typeof notice.translations === "object" ? notice.translations : {};
  const noticeLanguage = getDriverNoticeLanguage(language);
  const localized = translations[noticeLanguage] || translations.zh_cn || {};
  return {
    title: localized.title || notice?.title || "",
    body: localized.body || notice?.body || "",
  };
}

export function getDriverLanguage() {
  try {
    const queryLanguage = readLanguageQuery(['zh', ...driverLanguages.map(option => option.code)]);
    if (queryLanguage) return normalizeDriverLanguage(queryLanguage);
    return normalizeDriverLanguage(localStorage.getItem(DRIVER_LANGUAGE_KEY) || "zh_cn");
  } catch {
    return "zh_cn";
  }
}

export function getDriverHtmlLanguage(language = getDriverLanguage()) {
  const normalized = normalizeDriverLanguage(language);
  return {
    ja: "ja",
    en: "en",
    zh_cn: "zh-Hans",
    zh_tw: "zh-Hant",
  }[normalized] || "zh-Hans";
}

export function setDriverLanguagePreference(language) {
  const normalizedLanguage = normalizeDriverLanguage(language);
  updateLanguageQuery(normalizedLanguage);
  try {
    localStorage.setItem(DRIVER_LANGUAGE_KEY, normalizedLanguage);
  } catch {
    // Ignore storage failures in restricted WebView/private contexts.
  }
  try {
    window.dispatchEvent(new CustomEvent(DRIVER_LANGUAGE_CHANGED_EVENT, {
      detail: { language: normalizedLanguage },
    }));
  } catch {
    // Older WebViews can fail CustomEvent construction; storage still updated.
  }
  return normalizedLanguage;
}

export const weekdayNames = {
  ja: ["日", "月", "火", "水", "木", "金", "土"],
  en: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  zh_cn: ["日", "一", "二", "三", "四", "五", "六"],
  zh_tw: ["日", "一", "二", "三", "四", "五", "六"],
};

export function formatDriverDate(dateStr, { includeYear = false } = {}, language = getDriverLanguage()) {
  if (!dateStr) return "-";

  const date = new Date(dateStr);
  if (Number.isNaN(date.getTime())) return dateStr;

  const normalizedLanguage = weekdayNames[language] ? language : "zh_cn";
  const weekday = weekdayNames[normalizedLanguage][date.getDay()];
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();

  if (normalizedLanguage === "en") {
    return `${includeYear ? `${year}/` : ""}${month}/${day} (${weekday})`;
  }

  return `${includeYear ? `${year}年` : ""}${month}月${day}日 (${weekday})`;
}

export function getDriverText(language = getDriverLanguage()) {
  return driverText[normalizeDriverLanguage(language)] || driverText.zh_cn;
}

export function validateDriverTextCatalogs() {
  const expected = Object.keys(driverText.en).sort().join("|");
  Object.entries(driverText).forEach(([language, catalog]) => {
    if (Object.keys(catalog).sort().join("|") !== expected) {
      throw new Error(`driver_translation_keys_mismatch:${language}`);
    }
  });
  return true;
}
